import React, { Component } from 'react';
import axios from 'axios';
import Select from 'react-select';
import global from '../global';
import queryString from 'query-string';
import moment, { now } from 'moment';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Link } from 'react-router-dom';
import { NotificationContainer, NotificationManager } from 'react-notifications';
import Popup from './DocUploader';
import download from 'downloadjs'
import { Layout } from '../Layout';
import '../../Asset/vendors/base/vendors.bundle.css';
import '../../Asset/demo/default/base/style.bundle.css';
import '../../Asset/custom.css';
import { Row, Col, InputGroup, FormControl, Button } from 'react-bootstrap';
import Accordion from 'react-bootstrap/Accordion';
import Spinner from '../Spinner';
import ReactDOM from 'react-dom';
import ReactNotification from 'react-notifications-component';
import 'react-notifications-component/dist/theme.css'
import { store } from 'react-notifications-component';
import FilePreviewer from 'react-file-previewer';
import {
    Card,
    Alert,
    CardBody,
    NavItem,
    NavLink,
    Nav,
    TabContent,
    TabPane, Modal, ModalHeader, ModalBody, ModalFooter
} from "reactstrap";
import { config } from '../../Constants';

const customStyles = {
    content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        marginRight: '-50%',
        transform: 'translate(-50%, -50%)'
    }
};
const yesnooptions = [
    { value: '1', label: 'Yes' },
    { value: '0', label: 'No' },
]

const tablestyles = {
    table: {
        borderCollapse: "collapse",
        width: "100%"
    },
    cell: {
        border: "1px solid black",
        padding: "8px"
    },
    header: {
        border: "1px solid black",
        padding: "8px",
        backgroundColor: "#f2f2f2",
        color: "black",
        fontSize: "12px"
    }
}
export class Form121 extends Component {

    constructor(props) {
        super(props);
        this.state = {
            IsESign: 0,
            IsManualSign: 0,
            IsConsent: 0,
            isYesOpen: false,
            currentDate: moment().format("YYYY-MM-DD"),
            dob: '',
            AssignmentCode: -1,
            assignmentID: 0,
            base64Data: '',
            beneficiaryID: 0, beneficiaryName: '', PAN: '',
            previousYear: 0, residentialStatus: '', premisesName: '',
            street: '', area: '', city: '', zipCode: 0, flat: 0,
            states: '', showTextStates: 'block', showDrStates: 'none',
            FYID: 0, FYIDs: [], AYIDs: [], remitterID: 0, stdCode: 0,
            Countries: [], country: 0, formErrors: '',
            emailID: '', flag: '', remitterName: '', latestAssessmentYear: '',
            isClearable: true, isSearchable: true, drStates: [],
            formErrors: '', form: 'none', certificateNo: '',
            resStatus: [], residentialStatusID: 0, isFormG: 'none',
            statusDr: [], status: '', modal: false, showsignmodal: false,
            sections: [], sectionCode: '',
            file: '', filesToBeSent: '', FormType: '',
            isAccessToTax: '', assessmentYear: '', isAccessToTaxDr: [],
            estimateIncome: '0.0', estimateTotalIncome: '0.0',
            paidIncome: '0.0', datePaidIncome: moment().format('YYYY-MM-DD'),
            mobileNo: '', telephoneNo: 0, showAsessmentYr: 'none',
            countOfForm15: '', aggregateAmountIncome: '0.0',
            dividendDeclarationDates: [], dividendDeclarationDate: '',
            isHidden: '', pdfLocation: '', loading: true,
            url: '',
            buttonDisable: true,
            mainHtml: '', mainHtmlCount: 1, uniqueNo: '',
            isLatestAYDisable: true,
            latestAssessmentYearNew: null,
            size: 100,
            showModal: false,
            IsPanDisable: true,
            IsEmailDisable: true,
            RemitterCode: '',
            DigiPath: '',
            ManualPath: '',
            DPID: '',
            Limit: 300000,
            LimitH: 700000,
            FinalLimit: 300000,
            loaderText: 'Saving Declaration. Kindly Wait!',
            isLoaderButtonEnable: 'none',
            showLoaderModal: false,
            time: {}, seconds: 900, isFirstClick: 0, activeTabID: 'hTabsIcons-1', hTabsIcons: 'hTabsIcons-1', IsSaveCompleted: 0, IsFillCompleted: 0, IsSignCompleted: 0, IsDownloadCompleted: 0, IsStep2Enable: true, IsStep3Enable: true, IsStep4Enable: true, IsSubmitDisable: true, IsSaveDisable: false, IsESignDisable: false,
            assignmentCodes: atob(((new URL(document.location)).searchParams).get('AC')),
            DPIDs: atob(((new URL(document.location)).searchParams).get('DP')),
            RemitterList: [],
            IsOnlineOffline: '',
            CompletedCount: '',
            flag: '',
            StageID: '',
            age: '',
            drcountrycode: [],
            countrycode: '',
            otherform121filled: '',
            abover60yearsold:'',
            taxYear1: "",
            ackNo1: "",
            returnIncome1: "0",
            taxYear2: "",
            ackNo2: "",
            returnIncome2: "0",
            drPrevTwoyears: [],
            taxYear:""
            
        };



        const parsed = queryString.parse(window.location.search);
      


        this.state.AssignmentCode = parsed['AC'] == undefined ? 0 : window.atob(parsed['AC']);
        this.state.PAN = parsed['PN'] == undefined ? 0 : window.atob(parsed['PN']);
        this.state.DPID = parsed['DP'] == undefined ? 0 : window.atob(parsed['DP']);

        this.state.StageID = parsed['SID'] == undefined ? 0 : window.atob(parsed['SID']);
        this.state.IsOnlineOffline = parsed['OF'] == undefined ? 0 : window.atob(parsed['OF']);
        this.state.CompletedCount = parsed['CR'] == undefined ? '' : window.atob(parsed['CR']);
        this.state.flag = parsed['flag'] == undefined ? '' : window.atob(parsed['flag']);
        this.state.taxYear = parsed['FY'] == undefined ? '' : window.atob(parsed['FY']);

        axios.get(global.Form121.GetDetailsDDLAPI)
            .then(response => {

                const optionsAYID = response.data.fyid.map(d => ({
                    "value": d.ID,
                    "label": d.Label
                }))
                const optionsCountry = response.data.Countries.map(d => ({
                    "value": d.ID,
                    "label": d.Label
                }))
                const optionsState = response.data.States.map(d => ({
                    "value": d.ID,
                    "label": d.Label
                }))
                const optionsResStatus = response.data.ResidentialStatus.map(d => ({
                    "value": d.ID,
                    "label": d.Label
                }))
                const optionsStatus = response.data.Status.map(d => ({
                    "value": d.ID,
                    "label": d.Label
                }))
                const optionsSection = response.data.SectionCode.map(d => ({
                    "value": d.ID,
                    "label": d.Label
                }))
                const optionsAccess = response.data.AssessToTax.map(d => ({
                    "value": d.ID,
                    "label": d.Label
                }))

                const optionsRemitter = response.data.Remitter.map(d => ({
                    "value": d.ID,
                    "label": d.Label
                }))

                const optionscountrycode = response.data.Countries.map(d => ({
                    "value": d.CountryCode,
                    "label": d.CountryCode
                }))

                const previoustwoyears = response.data.LastTwoFY.map(d => ({
                    "value": d.label,
                    "label": d.label
                }))

                this.setState({ AYIDs: optionsAYID, Countries: optionsCountry, drStates: optionsState, resStatus: optionsResStatus, statusDr: optionsStatus, isAccessToTaxDr: optionsAccess, sections: optionsSection, RemitterList: optionsRemitter, drcountrycode: optionscountrycode,  drPrevTwoyears: previoustwoyears })
            })
            .catch(error => {
                this.setState({ loading: false });
            });

        if (this.state.IsOnlineOffline === '1') {
            axios.get(global.Form121.GetOfflineDetailsAPI + '?AssignmentCode=' + this.state.AssignmentCode + '&PAN=' + this.state.PAN + '&DPID=' + this.state.DPID + '&CompletedCount=' + this.state.CompletedCount)
                //{ headers: { "Authorization": `Bearer ${localStorage.getItem('token')}` } })
                .then(response => {

                    var CountOfForm15Op = '';

                    if (response.data.Form15GHDetails[0]["CountOfForm15"] == null || response.data.Form15GHDetails[0]["CountOfForm15"] == 0) {
                        CountOfForm15Op = '';
                    }
                    else {
                        CountOfForm15Op = response.data.Form15GHDetails[0]["CountOfForm15"];
                    }

                    var IsAccessToTaxOp = '';

                    if (response.data.Form15GHDetails[0]["IsAccessToTax"] == false) {
                        IsAccessToTaxOp = 0;
                    }
                    else if (response.data.Form15GHDetails[0]["IsAccessToTax"] == true) {
                        IsAccessToTaxOp = 1;
                    }

                    this.setState({
                        RemitterCode: response.data.Form15GHDetails[0]["RemitterCode"],
                        IsESign: response.data.Form15GHDetails[0]["IsESign"],
                        IsManualSign: response.data.Form15GHDetails[0]["IsManualSign"],
                        IsConsent: response.data.Form15GHDetails[0]["IsConsent"],
                        beneficiaryName: response.data.Form15GHDetails[0]["BeneficiaryName"],
                        remitterName: response.data.Form15GHDetails[0]["RemitterName"],
                        PAN: response.data.Form15GHDetails[0]["PAN"],
                        emailID: response.data.Form15GHDetails[0]["EmailID"],
                        dob: response.data.Form15GHDetails[0]["DOB"] == "1900-01-01" ? "" : response.data.Form15GHDetails[0]["DOB"],
                        premisesName: response.data.Form15GHDetails[0]["PremisesName"],
                        previousYear: response.data.Form15GHDetails[0]["PreviousYear"],
                        residentialStatus: response.data.Form15GHDetails[0]["ResidentialStatus"] === undefined ? 'Resident' : response.data.Form15GHDetails[0]["ResidentialStatus"],
                        flat: response.data.Form15GHDetails[0]["Flat"],
                        street: response.data.Form15GHDetails[0]["Street"],
                        area: response.data.Form15GHDetails[0]["Area"],
                        country: response.data.Form15GHDetails[0]["Country"],
                        city: response.data.Form15GHDetails[0]["City"],
                        country: response.data.Form15GHDetails[0]["CountryID"],
                        states: response.data.Form15GHDetails[0]["State"],
                        zipCode: response.data.Form15GHDetails[0]["ZipCode"],
                        stdCode: response.data.Form15GHDetails[0]["STDCode"],
                        status: response.data.Form15GHDetails[0]["Status"] == "" ? 'Individual' : response.data.Form15GHDetails[0]["Status"],
                        sectionCode: response.data.Form15GHDetails[0]["SectionCode"],
                        certificateNo: response.data.Form15GHDetails[0]["CertificateNo"],
                        uniqueNo: response.data.Form15GHDetails[0]["UniqueIdentificationNo"],
                        IsSubmitDisable: response.data.Form15GHDetails[0]["CertificateNo"] == "" ? true : false,
                        aggregateAmountIncome: response.data.Form15GHDetails[0]["AggregateAmountIncome"] == null ? '0' : response.data.Form15GHDetails[0]["AggregateAmountIncome"],
                        datePaidIncome: response.data.Form15GHDetails[0]["DatePaidIncome"] == null ? '' : moment(response.data.Form15GHDetails[0]["DatePaidIncome"]).format('YYYY-MM-DD'),
                        estimateIncome: response.data.Form15GHDetails[0]["EstimateIncome"] == null ? '' : response.data.Form15GHDetails[0]["EstimateIncome"],
                        estimateTotalIncome: response.data.Form15GHDetails[0]["EstimateTotalIncome"] == null ? '' : response.data.Form15GHDetails[0]["EstimateTotalIncome"],
                        isAccessToTax: IsAccessToTaxOp,
                        countOfForm15: CountOfForm15Op,
                        mobileNo: response.data.Form15GHDetails[0]["MobileNo"] == null ? '' : response.data.Form15GHDetails[0]["MobileNo"],
                        telephoneNo: response.data.Form15GHDetails[0]["TelephoneNo"] == null ? 0 : response.data.Form15GHDetails[0]["TelephoneNo"],
                        latestAssessmentYearNew: response.data.Form15GHDetails[0]["AssessmentYear"] == null ? '' : response.data.Form15GHDetails[0]["AssessmentYear"],
                        latestAssessmentYear: response.data.Form15GHDetails[0]["AssessmentFYYear"] == null ? '' : response.data.Form15GHDetails[0]["AssessmentFYYear"],
                        paidIncome: response.data.Form15GHDetails[0]["PaidIncome"] == null ? '' : response.data.Form15GHDetails[0]["PaidIncome"],
                        buttonDisable: response.data.Form15GHDetails[0]["CertificateNo"] == null ? true : false,
                        pdfLocation: response.data.Form15GHDetails[0]["PDFLoc"] == null ? '' : response.data.Form15GHDetails[0]["PDFLoc"],
                        IsStep2Enable: response.data.Form15GHDetails[0]["CertificateNo"] == "" ? true : false,
                        IsStep3Enable: response.data.Form15GHDetails[0]["IsFillCompleted"] == 1 ? false : true,
                        IsStep4Enable: response.data.Form15GHDetails[0]["IsSignCompleted"] == 1 ? false : true,
                        IsSaveCompleted: response.data.Form15GHDetails[0]["CertificateNo"] == "" ? 0 : 1,
                        IsFillCompleted: response.data.Form15GHDetails[0]["IsFillCompleted"],
                        IsSignCompleted: response.data.Form15GHDetails[0]["IsSignCompleted"],
                        IsDownloadCompleted: response.data.Form15GHDetails[0]["IsDownloadCompleted"],
                        DigiPath: response.data.Form15GHDetails[0]["DigiPath"],
                        ManualPath: response.data.Form15GHDetails[0]["ManualPath"],
                        remitterID: response.data.Form15GHDetails[0]["RemitterID"],
                        countrycode: response.data.Form15GHDetails[0]["countrycode"],
                        abover60yearsold: response.data.Form15GHDetails[0]["abover60yearsold"].toString(),
                        otherform121filled: response.data.Form15GHDetails[0]["otherform121filled"].toString(),
                        taxYear1: response.data.Form15GHDetails[0]["taxyear1"],
                        ackNo1: response.data.Form15GHDetails[0]["ackno1"],
                        returnIncome1: response.data.Form15GHDetails[0]["returnincome1"],
                        taxYear2: response.data.Form15GHDetails[0]["taxyear2"],
                        ackNo2: response.data.Form15GHDetails[0]["ackno2"],
                        returnIncome2: response.data.Form15GHDetails[0]["returnincome2"],
                        taxYear: response.data.Form15GHDetails[0]["taxyear"] !== "" && response.data.Form15GHDetails[0]["taxyear"] !== null  ? response.data.Form15GHDetails[0]["taxyear"] : this.state.taxYear
                    })
                    this.state.age = new Date(response.data.Form15GHDetails[0]["DOB"]);

                    if (response.data.Form15GHDetails[0]["EmailID"] == "" || response.data.Form15GHDetails[0]["EmailID"] == null) {
                        this.setState({
                            isEmailDisabled: false
                        });
                    }
                    else {
                        this.setState({
                            isEmailDisabled: true
                        });
                    }

                    if (this.state.IsSaveCompleted == 1) {
                        axios.get(global.Form121.DownloadPdfBase64API + this.state.pdfLocation,
                            {
                                headers: { "Authorization": `Bearer ${localStorage.getItem('token')}` }
                            })
                            .then(response => {
                                this.setState({ base64Data: decodeURIComponent(response.data), showModal: true });

                            })
                            .catch(error => {
                                this.showNoti("Notification", "Unable to Load Declaration", "danger");
                            });
                    }


                    if (this.state.isAccessToTax == 1)
                        this.setState({ showAsessmentYr: 'block', isLatestAYDisable: false, latestAssessmentYearNew: { value: this.state.latestAssessmentYearNew, label: this.state.latestAssessmentYear } });

                    if (this.state.IsFillCompleted == 1) {
                        this.setState({ IsSubmitDisable: true, IsSaveDisable: true });
                    }

                    if (this.state.IsSignCompleted == 1) {
                        this.setState({ IsSubmitDisable: true, IsSaveDisable: true, IsESignDisable: true });
                    }

                    if (this.state.isFirstClick == 0) {
                        this.timer = setInterval(this.countDown, 1000);
                        this.setState({ loading: false, time: {}, seconds: 900, isFirstClick: 1 });
                    }
                    else {
                        this.setState({ loading: false, time: {}, seconds: 900, isFirstClick: 1 });
                    }

                    if (this.state.StageID == 0) {
                        this.setState({ activeTabID: 'hTabsIcons-1', hTabsIcons: 'hTabsIcons-1' });
                    }
                    else if (this.state.StageID == 1) {
                        this.setState({ activeTabID: 'hTabsIcons-1', hTabsIcons: 'hTabsIcons-1' });
                    }
                    else if (this.state.StageID == 2) {
                        this.setState({ activeTabID: 'hTabsIcons-2', hTabsIcons: 'hTabsIcons-2' });
                    }
                    else if (this.state.StageID == 3) {
                        this.setState({ activeTabID: 'hTabsIcons-3', hTabsIcons: 'hTabsIcons-3' });
                    }
                    else if (this.state.StageID == 4) {
                        this.setState({ activeTabID: 'hTabsIcons-4', hTabsIcons: 'hTabsIcons-4' });
                    }

                })
                .catch(error => {
                    this.setState({ loading: false });;
                });

            axios.get(global.Form121.GetManuallyTaxLimitAPI + '?AssignmentCode=' + this.state.AssignmentCode + '&DPID=' + this.state.DPID)
                .then(response => {
                    this.setState({
                        Limit: response.data.Form15GHDetails[0]["TaxLimit"],
                        LimitH: response.data.Form15GHDetails[0]["TaxLimitH"]
                    })
                    var ageDifMs = Date.now() - this.state.age;
                    var actualDiff = new Date(ageDifMs)
                    var age_now = Math.abs(actualDiff.getUTCFullYear() - 1970);
                    if (age_now >= 60) {
                        this.state.FinalLimit = this.state.LimitH;
                    }
                    else {
                        this.state.FinalLimit = this.state.Limit;
                    }
                }).catch(error => {
                    this.setState({ loading: false });
                });
        }
        else {

            axios.get(global.Form121.GetDetailsAPI + '?AssignmentCode=' + this.state.AssignmentCode + '&PAN=' + this.state.PAN + '&DPID=' + this.state.DPID)
                //{ headers: { "Authorization": `Bearer ${localStorage.getItem('token')}` } })
                .then(response => {
                    if (response.data.status) {
                        var CountOfForm15Op = '';

                        if (response.data.Form15GHDetails[0]["CountOfForm15"] == null) {
                            CountOfForm15Op = '';
                        }
                        else if (response.data.Form15GHDetails[0]["CountOfForm15"] == 0) {
                            CountOfForm15Op = '';
                        }
                        else {
                            CountOfForm15Op = response.data.Form15GHDetails[0]["CountOfForm15"];

                        }

                        var IsAccessToTaxOp = '';

                        if (response.data.Form15GHDetails[0]["IsAccessToTax"] == false) {
                            IsAccessToTaxOp = 0;
                        }
                        else if (response.data.Form15GHDetails[0]["IsAccessToTax"] == true) {
                            IsAccessToTaxOp = 1;
                        }
                        else {
                            IsAccessToTaxOp = ''
                        }

                        this.setState({
                            RemitterCode: response.data.Form15GHDetails[0]["RemitterCode"],
                            IsESign: response.data.Form15GHDetails[0]["IsESign"],
                            IsManualSign: response.data.Form15GHDetails[0]["IsManualSign"],
                            IsConsent: response.data.Form15GHDetails[0]["IsConsent"],
                            beneficiaryName: response.data.Form15GHDetails[0]["BeneficiaryName"],
                            remitterName: response.data.Form15GHDetails[0]["RemitterName"],
                            PAN: response.data.Form15GHDetails[0]["PAN"],
                            emailID: response.data.Form15GHDetails[0]["EmailID"],
                            dob: response.data.Form15GHDetails[0]["DOB"] == "1900-01-01" ? "" : response.data.Form15GHDetails[0]["DOB"],
                            premisesName: response.data.Form15GHDetails[0]["PremisesName"],
                            previousYear: response.data.Form15GHDetails[0]["PreviousYear"],
                            residentialStatus: response.data.Form15GHDetails[0]["ResidentialStatus"] === undefined ? 'Resident' : response.data.Form15GHDetails[0]["ResidentialStatus"],
                            flat: response.data.Form15GHDetails[0]["Flat"],
                            street: response.data.Form15GHDetails[0]["Street"],
                            area: response.data.Form15GHDetails[0]["Area"],
                            country: response.data.Form15GHDetails[0]["Country"],
                            city: response.data.Form15GHDetails[0]["City"],
                            country: response.data.Form15GHDetails[0]["CountryID"],
                            states: response.data.Form15GHDetails[0]["State"],
                            zipCode: response.data.Form15GHDetails[0]["ZipCode"],
                            stdCode: response.data.Form15GHDetails[0]["STDCode"],
                            status: response.data.Form15GHDetails[0]["Status"] == "" ? 'Individual' : response.data.Form15GHDetails[0]["Status"],
                            sectionCode: response.data.Form15GHDetails[0]["SectionCode"],
                            certificateNo: response.data.Form15GHDetails[0]["CertificateNo"],
                            uniqueNo: response.data.Form15GHDetails[0]["UniqueIdentificationNo"],
                            IsSubmitDisable: response.data.Form15GHDetails[0]["CertificateNo"] == "" ? true : false,
                            aggregateAmountIncome: response.data.Form15GHDetails[0]["AggregateAmountIncome"] == null ? '0' : response.data.Form15GHDetails[0]["AggregateAmountIncome"],
                            datePaidIncome: response.data.Form15GHDetails[0]["DatePaidIncome"] == null ? '' : moment(response.data.Form15GHDetails[0]["DatePaidIncome"]).format('YYYY-MM-DD'),
                            estimateIncome: response.data.Form15GHDetails[0]["EstimateIncome"] == null ? '' : response.data.Form15GHDetails[0]["EstimateIncome"],
                            estimateTotalIncome: response.data.Form15GHDetails[0]["EstimateTotalIncome"] == null ? '' : response.data.Form15GHDetails[0]["EstimateTotalIncome"],
                            isAccessToTax: IsAccessToTaxOp,
                            countOfForm15: CountOfForm15Op,
                            mobileNo: response.data.Form15GHDetails[0]["MobileNo"] == null ? '' : response.data.Form15GHDetails[0]["MobileNo"],
                            telephoneNo: response.data.Form15GHDetails[0]["TelephoneNo"] == null ? 0 : response.data.Form15GHDetails[0]["TelephoneNo"],
                            latestAssessmentYearNew: response.data.Form15GHDetails[0]["AssessmentYear"] == null ? '' : response.data.Form15GHDetails[0]["AssessmentYear"],
                            latestAssessmentYear: response.data.Form15GHDetails[0]["AssessmentFYYear"] == null ? '' : response.data.Form15GHDetails[0]["AssessmentFYYear"],
                            paidIncome: response.data.Form15GHDetails[0]["PaidIncome"] == null ? '' : response.data.Form15GHDetails[0]["PaidIncome"],
                            buttonDisable: response.data.Form15GHDetails[0]["CertificateNo"] == null ? true : false,
                            pdfLocation: response.data.Form15GHDetails[0]["PDFLoc"] == null ? '' : response.data.Form15GHDetails[0]["PDFLoc"],
                            IsStep2Enable: response.data.Form15GHDetails[0]["CertificateNo"] == "" ? true : false,
                            IsStep3Enable: response.data.Form15GHDetails[0]["IsFillCompleted"] == 1 ? false : true,
                            IsStep4Enable: response.data.Form15GHDetails[0]["IsSignCompleted"] == 1 ? false : true,
                            IsSaveCompleted: response.data.Form15GHDetails[0]["CertificateNo"] == "" ? 0 : 1,
                            IsFillCompleted: response.data.Form15GHDetails[0]["IsFillCompleted"],
                            IsSignCompleted: response.data.Form15GHDetails[0]["IsSignCompleted"],
                            IsDownloadCompleted: response.data.Form15GHDetails[0]["IsDownloadCompleted"],
                            DigiPath: response.data.Form15GHDetails[0]["DigiPath"],
                            ManualPath: response.data.Form15GHDetails[0]["ManualPath"],
                            remitterID: response.data.Form15GHDetails[0]["RemitterID"],
                            countrycode: response.data.Form15GHDetails[0]["countrycode"],
                            abover60yearsold: response.data.Form15GHDetails[0]["abover60yearsold"].toString(),
                            otherform121filled: response.data.Form15GHDetails[0]["otherform121filled"].toString(),
                            taxYear1: response.data.Form15GHDetails[0]["taxyear1"],
                            ackNo1: response.data.Form15GHDetails[0]["ackno1"],
                            returnIncome1: response.data.Form15GHDetails[0]["returnincome1"],
                            taxYear2: response.data.Form15GHDetails[0]["taxyear2"],
                            ackNo2: response.data.Form15GHDetails[0]["ackno2"],
                            returnIncome2: response.data.Form15GHDetails[0]["returnincome2"],
                            taxYear: response.data.Form15GHDetails[0]["taxyear"] !== "" && response.data.Form15GHDetails[0]["taxyear"] !== null ? response.data.Form15GHDetails[0]["taxyear"] : this.state.taxYear
                        })
                        this.state.age = new Date(response.data.Form15GHDetails[0]["DOB"]);

                        if (response.data.Form15GHDetails[0]["EmailID"] == "" || response.data.Form15GHDetails[0]["EmailID"] == null) {
                            this.setState({
                                isEmailDisabled: false
                            });
                        }
                        else {
                            this.setState({
                                isEmailDisabled: true
                            });
                        }

                        if (response.data.Form15GHDetails[0]["RemitterName"] == "" || response.data.Form15GHDetails[0]["RemitterName"] == null) {
                            this.setState({
                                isRemitterDisable: false
                            });
                        }
                        else {
                            this.setState({
                                isRemitterDisable: true
                            });
                        }

                        if (response.data.Form15GHDetails[0]["BeneficiaryName"] == "" || response.data.Form15GHDetails[0]["BeneficiaryName"] == null) {
                            this.setState({
                                isbeneficiaryNameDisable: false
                            });
                        }
                        else {
                            this.setState({
                                isbeneficiaryNameDisable: true
                            });
                        }

                        if (response.data.Form15GHDetails[0]["PAN"] == "" || response.data.Form15GHDetails[0]["PAN"] == null) {
                            this.setState({
                                isPanDisable: false
                            });
                        }
                        else {
                            this.setState({
                                isPanDisable: true
                            });
                        }

                        if (response.data.Form15GHDetails[0]["Status"] == "" || response.data.Form15GHDetails[0]["Status"] == null) {
                            this.setState({
                                isStatusDisable: false
                            });
                        }
                        else {
                            this.setState({
                                isStatusDisable: true
                            });
                        }
                        if (response.data.Form15GHDetails[0]["PreviousYear"] == "" || response.data.Form15GHDetails[0]["PreviousYear"] == null) {
                            this.setState({
                                isPreviousYearDisabled: false
                            });
                        }
                        else {
                            this.setState({
                                isPreviousYearDisabled: true
                            });
                        }
                        if (response.data.Form15GHDetails[0]["ResidentialStatus"] == "" || response.data.Form15GHDetails[0]["ResidentialStatus"] == null) {
                            this.setState({
                                isresStatusDisabled: false
                            });
                        }
                        else {
                            this.setState({
                                isresStatusDisabled: true
                            });
                        }

                        if (this.state.IsSaveCompleted == 1) {
                            axios.get(global.Form121.DownloadPdfBase64API + this.state.pdfLocation,
                                {
                                    headers: { "Authorization": `Bearer ${localStorage.getItem('token')}` }
                                })
                                .then(response => {
                                    this.setState({ base64Data: decodeURIComponent(response.data), showModal: true });

                                })
                                .catch(error => {
                                    this.showNoti("Notification", "Unable to Load Declaration", "danger");
                                });
                        }


                        if (this.state.isAccessToTax == 1)
                            this.setState({ showAsessmentYr: 'block', isLatestAYDisable: false, latestAssessmentYearNew: { value: this.state.latestAssessmentYearNew, label: this.state.latestAssessmentYear } });

                        if (this.state.IsFillCompleted == 1) {
                            this.setState({ IsSubmitDisable: true, IsSaveDisable: true });
                        }

                        if (this.state.IsSignCompleted == 1) {
                            this.setState({ IsSubmitDisable: true, IsSaveDisable: true, IsESignDisable: true });
                        }


                        if (this.state.isFirstClick == 0) {
                            this.timer = setInterval(this.countDown, 1000);
                            this.setState({ loading: false, time: {}, seconds: 900, isFirstClick: 1 });
                        }
                        else {
                            this.setState({ loading: false, time: {}, seconds: 900, isFirstClick: 1 });
                        }

                        if (this.state.StageID == 0) {
                            this.setState({ activeTabID: 'hTabsIcons-1', hTabsIcons: 'hTabsIcons-1' });
                        }
                        else if (this.state.StageID == 1) {
                            this.setState({ activeTabID: 'hTabsIcons-1', hTabsIcons: 'hTabsIcons-1' });
                        }
                        else if (this.state.StageID == 2) {
                            this.setState({ activeTabID: 'hTabsIcons-2', hTabsIcons: 'hTabsIcons-2' });
                        }
                        else if (this.state.StageID == 3) {
                            this.setState({ activeTabID: 'hTabsIcons-3', hTabsIcons: 'hTabsIcons-3' });
                        }
                        else if (this.state.StageID == 4) {
                            this.setState({ activeTabID: 'hTabsIcons-4', hTabsIcons: 'hTabsIcons-4' });
                        }
                    }
                    else {
                        window.location.href = config.url.Web_URL;
                    }

                })
                .catch(error => {
                    this.setState({ loading: false });;
                });

            axios.get(global.Form121.GetTaxLimitAPI + '?AssignmentCode=' + this.state.AssignmentCode)
                .then(response => {
                    if (response.data.status) {
                        this.setState({
                            Limit: response.data.Form15GHDetails[0]["TaxLimit"],
                            LimitH: response.data.Form15GHDetails[0]["TaxLimitH"]
                        })
                        var ageDifMs = Date.now() - this.state.age;
                        var actualDiff = new Date(ageDifMs)
                        var age_now = Math.abs(actualDiff.getUTCFullYear() - 1970);
                        if (age_now >= 60) {
                            this.state.FinalLimit = this.state.LimitH;
                        }
                        else {
                            this.state.FinalLimit = this.state.Limit;
                        }
                    }
                    else {
                        window.location.href = config.url.Web_URL;
                    }
                }).catch(error => {
                    this.setState({ loading: false });
                });
        }


        this.timer = 0;
        this.startTimer = this.startTimer.bind(this);
        this.countDown = this.countDown.bind(this);

        this.initialstate = this.state;
        this.handleOpenModal = this.handleOpenModal.bind(this);
        this.handleCloseModal = this.handleCloseModal.bind(this);
    }

    secondsToTime(secs) {
        let hours = Math.floor(secs / (60 * 60));

        let divisor_for_minutes = secs % (60 * 60);
        let minutes = Math.floor(divisor_for_minutes / 60);

        let divisor_for_seconds = divisor_for_minutes % 60;
        let seconds = Math.ceil(divisor_for_seconds);

        let obj = {
            "h": hours,
            "m": minutes,
            "s": seconds
        };
        return obj;
    }

    handleOpenModal() {
        this.setState({ showModal: true });
    }

    handleCloseModal() {
        this.setState({ showModal: false });
    }

    handleSignCloseModal() {
        this.setState({ showsignmodal: false });
    }

    componentDidMount() {

        let timeLeftVar = this.secondsToTime(this.state.seconds);
        this.setState({ time: timeLeftVar });
    }

    startTimer() {
        if (this.timer == 0 && this.state.seconds > 0) {
            this.timer = setInterval(this.countDown, 1000);
        }
    }

    countDown() {
        // Remove one second, set state so a re-render happens.
        let seconds = this.state.seconds - 1;
        this.setState({
            time: this.secondsToTime(seconds),
            seconds: seconds,
        });

        // Check if we're at zero.
        if (seconds == 0) {
            clearInterval(this.timer);
        }
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.state.mainHtml !== '' && this.state.mainHtmlCount == 1) {
            this.state.mainHtmlCount = 2;
            this.refs.myFoo.submit();
        }

    }

    closeYesModal = () => this.setState({ isYesOpen: false });

    handleFormValidation = (e) => {
        const { dob, latestAssessmentYearNew, estimateIncome, estimateTotalIncome, paidIncome, datePaidIncome, PAN, mobileNo, states,
            residentialStatus, city, area, flat, previousYear, state, zipCode, dividendDeclarationDate, aggregateAmountIncome, countOfForm15, countrycode, otherform121filled, abover60yearsold } = this.state;

        let formErrors = {};
        let formIsValid = true;

        // aggregateAmountIncome

        if (countOfForm15 == "0" || countOfForm15 == "" || countOfForm15 == null) {

        }
        //if (this.state.aggregateAmountIncome == null) {
        //    formIsValid = false;
        //    formErrors["aggregateAmountIncomeErr"] = "Aggregate amount of income for which Form No.15H filed is required";
        //}
        //else {
        //    if (!aggregateAmountIncome) {
        //        formIsValid = false;
        //        formErrors["aggregateAmountIncomeErr"] = "Aggregate amount of income for which Form No.15H filed is required";
        //    }
        //}

        //Estimate Total Income
        if (!estimateTotalIncome) {
            formIsValid = false;
            formErrors["estimateTotalIncomeErr"] = "Estimate Total Income is required.";
        }

        //paid Income
        if (!paidIncome) {
            formIsValid = false;
            formErrors["paidIncomeErr"] = "Amount of Income Paid is required.";
        }

        //if (this.state.isAccessToTax) {
        //    //assessment Year
        //    if (this.state.showAsessmentYr) {
        //        if (!latestAssessmentYearNew) {
        //            formIsValid = false;
        //            formErrors["assessmentYearErr"] = "Assessment Year is required.";
        //        }
        //    }
        //}

        //Estimate Income
        if (!estimateIncome) {
            formIsValid = false;
            formErrors["estimateIncomeErr"] = "Estimate Income is required.";
        }

        //DOB    
        //if (!dob) {
        //    formIsValid = false;
        //    formErrors["DOBErr"] = "Date of Birth is required.";
        //}

        //city
        if (!city) {
            formIsValid = false;
            formErrors["cityErr"] = "City is required.";
        }

        //Area
        if (!area) {
            formIsValid = false;
            formErrors["areaErr"] = "Area is required.";
        }

        //Flat
        if (!flat) {
            formIsValid = false;
            formErrors["flatErr"] = "Flat/Door/Block No. is required.";
        }

        //previousYear
        //if (!previousYear) {
        //    formIsValid = false;
        //    formErrors["previousYearErr"] = "Previous Year is required.";
        //}

        //Zip Code
        if (!zipCode) {
            formIsValid = false;
            formErrors["zipCodeErr"] = "PIN is required.";
        } else if (!(/^[1-9][0-9]{5}$/.test(zipCode))) {
            formIsValid = false;
            formErrors["zipCodeErr"] = "Invalid PIN code.";
        }

        //Mobile No
        if (!mobileNo) {
            formIsValid = false;
            formErrors["mobileNoErr"] = "Mobile number is required.";
        } else if (mobileNo.length > 10 || mobileNo.length < 10) {
            formIsValid = false;
            formErrors["mobileNoErr"] = "Invalid Mobile number.";
        }

        if (this.state.isFormG == 'block') {
            if (!residentialStatus) {
                formIsValid = false;
                formErrors["residentialStatusErr"] = "Residential status is required.";
            }

            //if (!states) {
            //    formIsValid = false;
            //    formErrors["stateErr"] = "State is required.";
            //}
        }

        if (!states) {
            formIsValid = false;
            formErrors["stateErr"] = "State is required.";
        }

        if (!countrycode) {
            formIsValid = false;
            formErrors["countrycodeerr"] = "Country code is required.";
        }

        if (!abover60yearsold) {
            formIsValid = false;
            formErrors["above60yearsolderr"] = "Whether above 60 years old is required.";
        }

        if (!otherform121filled) {
            formIsValid = false;
            formErrors["otherform121fillederr"] = "Details of any other Form 121 filled is required.";
        }

        if (this.state.estimateIncome.length <= 7 && !isNaN(Number(this.state.estimateIncome))) {

            if (parseInt(this.state.estimateIncome) > this.state.FinalLimit) {

                formIsValid = false;
                formErrors["estimateIncomeErr"] = "Estimated income for which this declaration is made should be less then " + this.state.FinalLimit;
            }
            else {

                var NewAvaliableValue = this.state.FinalLimit - parseInt(this.state.estimateIncome);

                if (parseInt(this.state.aggregateAmountIncome) > NewAvaliableValue) {
                    formIsValid = false;
                    formErrors["aggregateAmountIncomeErr"] = "The sum of Aggregate amount & Estimated income should not be greater then " + this.state.FinalLimit;
                }


                var aggregateAmountIncomeNew = 0;

                if (this.state.aggregateAmountIncome == "NaN" || this.state.aggregateAmountIncome == "") {
                    aggregateAmountIncomeNew = 0;
                }
                else {
                    aggregateAmountIncomeNew = this.state.aggregateAmountIncome;
                }

                var estimateTotalIncomeNew = 0;

                if (this.state.estimateTotalIncome == "NaN" || this.state.estimateTotalIncome == "") {
                    estimateTotalIncomeNew = 0;
                }
                else {
                    estimateTotalIncomeNew = this.state.estimateTotalIncome;
                }

                var valNeww = 0;

                if (this.state.estimateIncome == "NaN" || this.state.estimateIncome == "") {
                    valNeww = 0;
                }
                else {
                    valNeww = this.state.estimateIncome;
                }

                var NewVAl = parseInt(aggregateAmountIncomeNew) + parseInt(valNeww);

                if (parseInt(estimateTotalIncomeNew) < NewVAl) {
                    formIsValid = false;
                    formErrors["estimateTotalIncomeErr"] = "Estimated income of FY should not be lower than sum of estimated income for which this declaration is made & Aggregate amount of income for which Form No.121 filed.";
                }

            }

        }

        if (this.state.estimateTotalIncome.length <= 7 && !isNaN(Number(this.state.estimateTotalIncome))) {
            if (parseInt(this.state.estimateTotalIncome) > this.state.FinalLimit) {
                formIsValid = false;
                formErrors["estimateTotalIncomeErr"] = "Estimated total income of the FY should be less then " + this.state.FinalLimit;
                this.setState({ formErrors: formErrors });
            }
            else {
                var aggregateAmountIncomeNew = 0;

                if (this.state.aggregateAmountIncome == "NaN" || this.state.aggregateAmountIncome == "") {
                    aggregateAmountIncomeNew = 0;
                }
                else {
                    aggregateAmountIncomeNew = this.state.aggregateAmountIncome;
                }

                var estimateIncomeNew = 0;

                if (this.state.estimateIncome == "NaN" || this.state.estimateIncome == "") {
                    estimateIncomeNew = 0;
                }
                else {
                    estimateIncomeNew = this.state.estimateIncome;
                }

                var valNeww = 0;

                if (this.state.estimateTotalIncome == "NaN" || this.state.estimateTotalIncome == "") {
                    valNeww = 0;
                }
                else {
                    valNeww = this.state.estimateTotalIncome;
                }

                var NewVAl = parseInt(aggregateAmountIncomeNew) + parseInt(estimateIncomeNew);

                if (parseInt(valNeww) < NewVAl) {
                    formIsValid = false;
                    formErrors["estimateTotalIncomeErr"] = "Estimated income of FY should not be lower than sum of estimated income for which this declaration is made & Aggregate amount of income for which Form No.121 filed.";
                }

            }
        }

        if (this.state.aggregateAmountIncome.length <= 7 && !isNaN(Number(this.state.aggregateAmountIncome))) {

            var estimateTotalIncomeNew = 0;

            if (this.state.estimateTotalIncome == "NaN" || this.state.estimateTotalIncome == "") {
                estimateTotalIncomeNew = 0;
            }
            else {
                estimateTotalIncomeNew = this.state.estimateTotalIncome;
            }

            var estimateIncomeNew = 0;

            if (this.state.estimateIncome == "NaN" || this.state.estimateIncome == "") {
                estimateIncomeNew = 0;
            }
            else {
                estimateIncomeNew = this.state.estimateIncome;
            }

            var valNeww = 0;

            if (this.state.aggregateAmountIncome == "NaN" || this.state.aggregateAmountIncome == "") {
                valNeww = 0;
            }
            else {
                valNeww = this.state.aggregateAmountIncome;
            }


            var NewVAl = parseInt(valNeww) + parseInt(estimateIncomeNew);

            if (parseInt(estimateTotalIncomeNew) < NewVAl) {
                formIsValid = false;
                formErrors["estimateTotalIncomeErr"] = "Estimated income of FY should not be lower than sum of estimated income for which this declaration is made & Aggregate amount of income for which Form No.121 filed.";
            }


            var NewAvaliableValue = this.state.FinalLimit - parseInt(this.state.estimateIncome);

            if (parseInt(this.state.aggregateAmountIncome) > NewAvaliableValue) {
                formIsValid = false;
                formErrors["aggregateAmountIncomeErr"] = "The sum of Aggregate amount & Estimated income should not be greater then " + this.state.FinalLimit;
            }
            else {

                if (this.state.countOfForm15 == "0" || this.state.countOfForm15 == "" || this.state.countOfForm15 == null) {

                }
                else {
                    if (this.state.aggregateAmountIncome != "") {

                    }
                    else {
                        formIsValid = false;
                        formErrors["aggregateAmountIncomeErr"] = "Aggregate amount of income for which Form No.15H filed is required";
                    }

                }
            }

        }

        if (this.state.paidIncome.length <= 7 && !isNaN(Number(this.state.paidIncome))) {
            if (parseInt(this.state.paidIncome) > this.state.FinalLimit) {
                formIsValid = false;
                formErrors["paidIncomeErr"] = "Amount of income paid should be less then " + this.state.FinalLimit;
            }
        }
        if (this.state.ackNo1 !== '' && this.state.ackNo1 != null) {
            if (this.state.ackNo1.length != 15) {
                this.setState({ loading: false });
                this.showNoti("Notification", "Acknowledgement No of year " + this.state.taxYear1 + " should be of length 15 digits", "danger");
                formIsValid = false;
            }
        }

        if (this.state.ackNo2 !== '' && this.state.ackNo2 != null) {
            if (this.state.ackNo2.length != 15) {
                this.setState({ loading: false });
                this.showNoti("Notification", "Acknowledgement No of year " + this.state.taxYear2 + " should be of length 15 digits", "danger");
                formIsValid = false;
            }
        }

        
        //formIsValid = false;
        const { name, value } = e.target;
        this.setState({ [name]: value });
        this.setState({ formErrors: formErrors });

        return formIsValid;
    }

    handleChange = (e) => {
        const { name, value } = e.target;

        if ([name] == "PAN") {
            this.setState({ [name]: value.toUpperCase() });
        }
        else {
            this.setState({ [name]: value });
        }

        if ([name] == "returnIncome1" || [name] == "returnIncome2") {
            this.setState({ [name]: value==""?null:value });
        }
        if ([name] == "dob") {
            var getdob = e.target.value;
            var dob = new Date(getdob);

            var today = new Date();

            var fyEndYear;
            if (today.getMonth() > 2) {
                fyEndYear = today.getFullYear();
            } else {
                fyEndYear = today.getFullYear()-1;
            }

            var referenceDate = new Date(fyEndYear, 2, 31);

            var age_now = referenceDate.getFullYear() - dob.getFullYear();

            var m = referenceDate.getMonth() - dob.getMonth();
            if (m < 0 || (m === 0 && referenceDate.getDate() < dob.getDate())) {
                age_now--;
            }

            if (age_now >= 60) {
                this.setState({ abover60yearsold: '1' });
                this.setState({ FinalLimit: this.state.LimitH });
            } else {
                this.setState({ abover60yearsold: '0' });
                this.setState({ FinalLimit: this.state.Limit });
            }
        }

    }

    handleNumericChange = (e) => {
        const { name, value } = e.target;
        let formErrors = {};
        let formIsValid = true;

        if (value.length <= 6 && !isNaN(Number(value)) && [name] == "zipCode") {
            this.setState({ [name]: value });
        }
        if (value.length <= 5 && !isNaN(Number(value)) && [name] == "stdCode") {
            this.setState({ [name]: value });
        }

        if (value.length <= 15 && !isNaN(Number(value)) && [name] == "telephoneNo") {
            this.setState({ [name]: value });
        }

        if (value.length <= 10 && !isNaN(Number(value)) && [name] == "mobileNo") {
            this.setState({ [name]: value });
        }

        if (value.length <= 15 && !isNaN(Number(value)) && [name] == "ackNo1") {
            this.setState({ [name]: value });
        }

        if (value.length <= 15 && !isNaN(Number(value)) && [name] == "ackNo2") {
            this.setState({ [name]: value });
        }

        if (value.length < 10 && !isNaN(Number(value)) && [name] == "mobileNo") {
            formIsValid = false;
            formErrors["mobileNoErr"] = "Mobile No. should be of 10 digits";

            this.setState({ [name]: value, formErrors: formErrors });
        }

        if (value.length == 10 && !isNaN(Number(value)) && [name] == "mobileNo") {
            formIsValid = true;
            formErrors["mobileNoErr"] = "";

            this.setState({ [name]: value, formErrors: formErrors });
        }


        if (value.length <= 7 && !isNaN(Number(value)) && [name] == "estimateIncome") {

            if (parseInt(value) > this.state.FinalLimit) {

                formIsValid = false;
                formErrors["estimateIncomeErr"] = "Estimated income for which this declaration is made should be less then " + this.state.FinalLimit;

                this.setState({ [name]: "0", formErrors: formErrors });

            }
            else {

                formIsValid = true;
                formErrors["estimateIncomeErr"] = "";
                formErrors["aggregateAmountIncomeErr"] = "";
                formErrors["estimateTotalIncomeErr"] = "";

                var NewAvaliableValue = this.state.FinalLimit - parseInt(value);

                formIsValid = true;
                formErrors["aggregateAmountIncomeErr"] = "";

                var aggregateAmountIncomeNew = 0;

                if (this.state.aggregateAmountIncome == "NaN" || this.state.aggregateAmountIncome == "") {
                    aggregateAmountIncomeNew = 0;
                }
                else {
                    aggregateAmountIncomeNew = this.state.aggregateAmountIncome;
                }

                var estimateTotalIncomeNew = 0;

                if (this.state.estimateTotalIncome == "NaN" || this.state.estimateTotalIncome == "") {
                    estimateTotalIncomeNew = 0;
                }
                else {
                    estimateTotalIncomeNew = this.state.estimateTotalIncome;
                }

                var valNeww = 0;

                if (value == "NaN" || value == "") {
                    valNeww = 0;
                }
                else {
                    valNeww = value;
                }

                var NewVAl = parseInt(aggregateAmountIncomeNew) + parseInt(valNeww);

                if (parseInt(estimateTotalIncomeNew) < NewVAl) {
                    formIsValid = false;
                    formErrors["estimateTotalIncomeErr"] = "Estimated income of FY should not be lower than sum of estimated income for which this declaration is made & Aggregate amount of income for which Form No.121 filed.";
                }
                else {
                    formIsValid = true;
                    formErrors["estimateTotalIncomeErr"] = "";
                }

                this.setState({ [name]: value, formErrors: formErrors, paidIncome: value });

            }
        }

        if (value.length <= 7 && !isNaN(Number(value)) && [name] == "estimateTotalIncome") {
            if (parseInt(value) > this.state.FinalLimit) {
                formIsValid = false;
                formErrors["estimateTotalIncomeErr"] = "Estimated total income of the FY should be less then " + this.state.FinalLimit;
                this.setState({ [name]: "0", formErrors: formErrors });
            }
            else {

                var aggregateAmountIncomeNew = 0;

                if (this.state.aggregateAmountIncome == "NaN" || this.state.aggregateAmountIncome == "") {
                    aggregateAmountIncomeNew = 0;
                }
                else {
                    aggregateAmountIncomeNew = this.state.aggregateAmountIncome;
                }

                var estimateIncomeNew = 0;

                if (this.state.estimateIncome == "NaN" || this.state.estimateIncome == "") {
                    estimateIncomeNew = 0;
                }
                else {
                    estimateIncomeNew = this.state.estimateIncome;
                }

                var valNeww = 0;

                if (value == "NaN" || value == "") {
                    valNeww = 0;
                }
                else {
                    valNeww = value;
                }

                var NewVAl = parseInt(aggregateAmountIncomeNew) + parseInt(estimateIncomeNew);

                if (parseInt(valNeww) < NewVAl) {
                    formIsValid = false;
                    formErrors["estimateTotalIncomeErr"] = "Estimated income of FY should not be lower than sum of estimated income for which this declaration is made & Aggregate amount of income for which Form No.121 filed.";
                }
                else {
                    formIsValid = true;
                    formErrors["estimateTotalIncomeErr"] = "";
                }

                this.setState({ [name]: value, formErrors: formErrors });
            }
        }

        if (value.length <= 2 && !isNaN(Number(value)) && [name] == "countOfForm15") {
            this.setState({ [name]: value });
        }
        if (value.length <= 4 && !isNaN(Number(value)) && [name] == "assessmentYear") {
            this.setState({ [name]: value });
        }
        if (value.length <= 7 && !isNaN(Number(value)) && [name] == "aggregateAmountIncome") {

            var estimateTotalIncomeNew = 0;

            if (this.state.estimateTotalIncome == "NaN" || this.state.estimateTotalIncome == "") {
                estimateTotalIncomeNew = 0;
            }
            else {
                estimateTotalIncomeNew = this.state.estimateTotalIncome;
            }

            var estimateIncomeNew = 0;

            if (this.state.estimateIncome == "NaN" || this.state.estimateIncome == "") {
                estimateIncomeNew = 0;
            }
            else {
                estimateIncomeNew = this.state.estimateIncome;
            }

            var valNeww = 0;

            if (value == "NaN" || value == "") {
                valNeww = 0;
            }
            else {
                valNeww = value;
            }


            var NewVAl = parseInt(valNeww) + parseInt(estimateIncomeNew);

            if (parseInt(estimateTotalIncomeNew) < NewVAl) {
                formIsValid = false;
                formErrors["estimateTotalIncomeErr"] = "Estimated income of FY should not be lower than sum of estimated income for which this declaration is made & Aggregate amount of income for which Form No.121 filed.";
            }
            else {
                formIsValid = true;
                formErrors["estimateTotalIncomeErr"] = "";
            }

            var NewAvaliableValue = this.state.FinalLimit - parseInt(this.state.estimateIncome);

            if (parseInt(value) > NewAvaliableValue) {
                formIsValid = false;
                formErrors["aggregateAmountIncomeErr"] = "The sum of Aggregate amount & Estimated income should not be greater then " + this.state.FinalLimit;

                this.setState({ [name]: "0", formErrors: formErrors });

            }
            else {

                if (this.state.countOfForm15 == "0" || this.state.countOfForm15 == "" || this.state.countOfForm15 == null) {
                    formIsValid = true;
                    formErrors["aggregateAmountIncomeErr"] = "";
                }
                else {
                    if (value != "") {
                        formIsValid = true;
                        formErrors["aggregateAmountIncomeErr"] = "";
                    }
                    else {
                        formIsValid = false;
                        formErrors["aggregateAmountIncomeErr"] = "Aggregate amount of income for which Form No.15H filed is required";
                    }

                }

                this.setState({ [name]: value, formErrors: formErrors });
            }


        }

        if (value.length <= 7 && !isNaN(Number(value)) && [name] == "paidIncome") {
            if (parseInt(value) > this.state.FinalLimit) {
                formIsValid = false;
                formErrors["paidIncomeErr"] = "Amount of income paid should be less then " + this.state.FinalLimit;

                this.setState({ [name]: "0", formErrors: formErrors });

            }
            else {
                formIsValid = true;
                formErrors["paidIncomeErr"] = "";

                this.setState({ [name]: value, formErrors: formErrors });
            }

            if (parseInt(value) != parseInt(this.state.estimateIncome)) {
                formIsValid = false;
                formErrors["paidIncomeErr"] = "Amount of income paid should be equal to Estimated income for which this declaration is made";

                this.setState({ [name]: value, formErrors: formErrors });
            }
            else {
                formIsValid = true;
                formErrors["paidIncomeErr"] = "";

                this.setState({ [name]: value, formErrors: formErrors });
            }
        }

        if (parseInt(value) < 0) {
            this.setState({ [name]: '' });
        }

    }

    togglePopup = () => {
        this.setState({ modal: false })
    }

    handleOnAutoSubmit = e => {
        e.preventDefault();
    };

    handlePreviewSubmit = (e) => {

        if (this.state.isAccessToTax == 1) {
            this.state.latestAssessmentYearNew = this.state.latestAssessmentYearNew.label;
        }
        else {
            this.state.latestAssessmentYearNew = '';
        }

        this.setState({ loading: true });

        const demoForm15GH = this.state;

        axios.post(global.Form121.PreviewForm121DetailsAPI, demoForm15GH,
            {
                headers: { "Authorization": `Bearer ${localStorage.getItem('token')}` }
            })
            .then(json => {
                if (json.data.status) {
                    this.state.pdfLocation = json.data.pDFLocation;
                    this.state.certificateNo = json.data.certificateNo;

                    if (this.state.isAccessToTax == 1) {
                        this.setState({ latestAssessmentYearNew: { value: this.state.latestAssessmentYearNew, label: this.state.latestAssessmentYear } });
                    }
                    else {
                        this.state.latestAssessmentYearNew = '';
                    }

                    if (this.state.isFirstClick == 0) {
                        this.timer = setInterval(this.countDown, 1000);
                        this.setState({ loading: false, showLoaderModal: false, base64Data: decodeURIComponent(json.data.base64Data), IsSubmitDisable: false, time: {}, seconds: 900, isFirstClick: 1, activeTabID: 'hTabsIcons-2', hTabsIcons: 'hTabsIcons-2', IsSaveCompleted: 1, IsStep2Enable: false, });
                    }
                    else {
                        this.setState({ loading: false, showLoaderModal: false, base64Data: decodeURIComponent(json.data.base64Data), IsSubmitDisable: false, time: {}, seconds: 900, isFirstClick: 1, activeTabID: 'hTabsIcons-2', hTabsIcons: 'hTabsIcons-2', IsSaveCompleted: 1, IsStep2Enable: false, });
                    }

                    this.showNoti("Notification", global.Message.SuccessMessage, "success");

                }
                else {
                    this.setState({ loading: false });
                    this.showNoti("Notification", json.Message == undefined ? global.Message.FailedSave : json.Message, "danger");
                }

            })
            .catch(error => {
                this.setState({ loading: false });
            });
    }

    handleSubmit = (e) => {
        this.setState({ loading: true });


        if (this.state.PAN == '' || this.state.PAN == null) {
            this.setState({ loading: false });
            this.showNoti("Notification", "PAN is Required", "danger");
            return;
        }

        var regex = /[A-Z]{5}[0-9]{4}[A-Z]{1}$/;
        if (!regex.test(this.state.PAN)) {
            this.setState({ loading: false });
            this.showNoti("Notification", "Invalid PAN", "danger");
            return;
        }

        if (this.state.emailID == '' || this.state.emailID == null) {
            this.setState({ loading: false });
            this.showNoti("Notification", "Email is Required", "danger");
            return;
        }

        var emailformat = /^(?!.*\.\.)(?!.*\.$)[A-Za-z0-9._%+-]{1,64}@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/;
        if (!emailformat.test(this.state.emailID)) {
            this.setState({ loading: false });
            this.showNoti("Notification", "Invalid Email Address", "danger");
            return;
        }

        if (this.state.dob == '' || this.state.dob == null) {
            this.setState({ loading: false });
            this.showNoti("Notification", "Date of Birth is Required", "danger");
            return;
        }

        if (this.handleFormValidation(e)) {

            //if (this.state.dob == 'Invalid date') {
            //    this.setState({ loading: false });
            //    this.showNoti("Notification", "Date of Birth is Required", "danger");
            //    return;
            //}

            //if (this.state.dob == '') {
            //    this.setState({ loading: false });
            //    this.showNoti("Notification", "Date of Birth is Required", "danger");
            //    return;
            //}

            //var today = new Date();
            //var birthDate = new Date(this.state.dob);

            //var age = today.getFullYear() - birthDate.getFullYear();

            //var m = today.getMonth() - birthDate.getMonth();
            //if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
            //    age--;
            //}

            //if (age < 18) {
            //    this.setState({ loading: false });
            //    this.showNoti("Notification", "Age should be greater than 18", "danger");
            //    return;
            //}

            this.state.flag = 'I';
            this.state.aggregateAmountIncome = this.state.aggregateAmountIncome == '' ? 0.0 : this.state.aggregateAmountIncome;
            this.state.countOfForm15 = this.state.countOfForm15 == '' ? 0 : this.state.countOfForm15;

            if (this.state.isAccessToTax == 1) {
                this.state.latestAssessmentYearNew = this.state.latestAssessmentYearNew.label;
            }
            else {
                this.state.latestAssessmentYearNew = '';
            }

            const demoForm15GH = this.state;

            this.setState({ loading: false, showLoaderModal: true });
            axios.post(global.Form121.CheckSubsequentDividendsAPI, demoForm15GH,
                {
                    headers: { "Authorization": `Bearer ${localStorage.getItem('token')}` }
                })
                .then(response => {
                    if (response.data.Status) {

                        if (response.data.DataExist == "Yes") {
                            this.setState({
                                isYesOpen: true,
                            });

                            this.setState({ loading: false, showLoaderModal: false });
                        }
                        else {
                            this.setState({ loading: false, showLoaderModal: true });

                            axios.post(global.Form121.IForm121API, demoForm15GH,
                                {
                                    headers: { "Authorization": `Bearer ${localStorage.getItem('token')}` }
                                })
                                .then(json => {
                                    if (json.data.status) {

                                        this.state.pdfLocation = json.data.pDFLocation;
                                        this.state.certificateNo = json.data.certificateNo;
                                        if (this.state.isAccessToTax == 1) {
                                            this.setState({ isYesOpen: false, latestAssessmentYearNew: { value: this.state.latestAssessmentYearNew, label: this.state.latestAssessmentYear } });
                                        }
                                        else {
                                            this.state.latestAssessmentYearNew = '';
                                        }

                                        this.setState({ isYesOpen: false, loaderText: 'Declaration Saved Successfully. Click ‘Submit’ to proceed', isLoaderButtonEnable: 'block' });

                                    }
                                    else {
                                        this.setState({ loading: false, showLoaderModal: false });
                                        if (json.data.message === "Estimate Income not match") {
                                            this.showNoti("Notification", "Estimate income should be less than or equal to Tax Limit", "danger");
                                        }
                                        else {
                                            this.showNoti("Notification", json.Message == undefined ? global.Message.FailedSave : json.data.message, "danger");
                                        }

                                    }
                                })
                                .catch(error => {
                                    this.setState({ loading: false, showLoaderModal: false });
                                });
                        }

                    } else {
                        this.setState({ loading: false, showLoaderModal: false });
                        this.showNoti("Notification", "Unable to Check Subsequent Dividends", "danger");
                        return;
                    }
                })
                .catch(error => {
                });


        }
        else {
            this.setState({ loading: false, showLoaderModal: false });
            this.showNoti("Notification", global.Message.RequiredMessage, "danger");
        }
    }

    handleSubmit2 = (e) => {
        this.setState({ loading: true });

        if (this.state.PAN == '' || this.state.PAN == null) {
            this.setState({ loading: false });
            this.showNoti("Notification", "PAN is Required", "danger");
            return;
        }

        var regex = /[A-Z]{5}[0-9]{4}[A-Z]{1}$/;
        if (!regex.test(this.state.PAN)) {
            this.setState({ loading: false });
            this.showNoti("Notification", "Invalid PAN", "danger");
            return;
        }

        if (this.state.emailID == '' || this.state.emailID == null) {
            this.setState({ loading: false });
            this.showNoti("Notification", "Email is Required", "danger");
            return;
        }

        //var mailformat = /^[a-zA-Z0-9]+@[a-zA-Z0-9]+\.[A-Za-z]+$/;
        //if (!mailformat.test(this.state.emailID)) {
        //    this.setState({ loading: false });
        //    this.showNoti("Notification", "Invalid Email", "danger");
        //    return;
        //}

        if (this.handleFormValidation(e)) {

            //if (this.state.dob == 'Invalid date') {
            //    this.setState({ loading: false });
            //    this.showNoti("Notification", "Date of Birth is Required", "danger");
            //    return;
            //}

            //if (this.state.dob == '') {
            //    this.setState({ loading: false });
            //    this.showNoti("Notification", "Date of Birth is Required", "danger");
            //    return;
            //}

            //var today = new Date();
            //var birthDate = new Date(this.state.dob);

            //var age = today.getFullYear() - birthDate.getFullYear();

            //var m = today.getMonth() - birthDate.getMonth();
            //if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
            //    age--;
            //}

            //if (age < 18) {
            //    this.setState({ loading: false });
            //    this.showNoti("Notification", "Age should be greater than 18", "danger");
            //    return;
            //}

            this.state.flag = 'I';
            this.state.aggregateAmountIncome = this.state.aggregateAmountIncome == '' ? 0.0 : this.state.aggregateAmountIncome;
            this.state.countOfForm15 = this.state.countOfForm15 == '' ? 0 : this.state.countOfForm15;

            if (this.state.isAccessToTax == 1) {
                this.state.latestAssessmentYearNew = this.state.latestAssessmentYearNew.label;
            }
            else {
                this.state.latestAssessmentYearNew = '';
            }

            const demoForm15GH = this.state;

            this.setState({ loading: false, showLoaderModal: true });

            axios.post(global.Form121.IForm121API, demoForm15GH,
                {
                    headers: { "Authorization": `Bearer ${localStorage.getItem('token')}` }
                })
                .then(json => {
                    if (json.data.status) {
                        this.state.pdfLocation = json.data.pDFLocation;
                        this.state.certificateNo = json.data.certificateNo;
                        if (this.state.isAccessToTax == 1) {
                            this.setState({ isYesOpen: false, latestAssessmentYearNew: { value: this.state.latestAssessmentYearNew, label: this.state.latestAssessmentYear } });
                        }
                        else {
                            this.state.latestAssessmentYearNew = '';
                        }

                        this.setState({ isYesOpen: false, loaderText: 'Declaration Saved Successfully. Click ‘Submit’ to proceed', isLoaderButtonEnable: 'block' });

                    }
                    else {
                        this.setState({ loading: false, showLoaderModal: false });
                        this.showNoti("Notification", json.Message == undefined ? global.Message.FailedSave : json.Message, "danger");
                    }

                })
                .catch(error => {
                    this.setState({ loading: false, showLoaderModal: false });
                });
        }
        else {
            this.setState({ loading: false, showLoaderModal: false });
            this.showNoti("Notification", global.Message.RequiredMessage, "danger");
        }
    }

    handleOpenPopUp = (e) => {

        this.setState({ loading: true });

        if (this.handleFormValidation(e)) {
            this.state.flag = 'I';
            this.state.aggregateAmountIncome = this.state.aggregateAmountIncome == '' ? 0.0 : this.state.aggregateAmountIncome;
            this.state.countOfForm15 = this.state.countOfForm15 == '' ? 0 : this.state.countOfForm15;
            const latestAssessmentYearNewOrg = this.state.latestAssessmentYearNew;
            this.state.latestAssessmentYearNew = this.state.latestAssessmentYearNew.label;

            const demoForm15GH = this.state;

            axios.post(global.Form121.SubmitForm121API, demoForm15GH,
                {
                    headers: { "Authorization": `Bearer ${localStorage.getItem('token')}` }
                })
                .then(json => {
                    if (json.data.status) {
                        this.state.certificateNo = json.data.certificateNo;
                        this.state.pdfLocation = json.data.pDFLocation;
                        this.state.uniqueNo = json.data.uniqueNo;
                        if (this.state.isFirstClick == 0) {
                            this.timer = setInterval(this.countDown, 1000);
                            this.setState({ loading: false, IsSubmitDisable: false, IsSaveDisable: false, activeTabID: 'hTabsIcons-3', hTabsIcons: 'hTabsIcons-3', IsSaveCompleted: 1, IsFillCompleted: 1, IsStep3Enable: false, time: {}, seconds: 900, isFirstClick: 1, latestAssessmentYearNew: latestAssessmentYearNewOrg });
                        }
                        else {
                            this.setState({ loading: false, IsSaveDisable: false, activeTabID: 'hTabsIcons-3', hTabsIcons: 'hTabsIcons-3', IsSaveCompleted: 1, IsFillCompleted: 1, IsStep3Enable: true, time: {}, seconds: 900, isFirstClick: 1, latestAssessmentYearNew: latestAssessmentYearNewOrg });
                            this.state = {
                                IsSubmitDisable: false // Initial state value
                            };
                            //this.state.IsSubmitDisable: false
                        }
                        this.showNoti("Notification", global.Message.SubmitMessage, "success");
                    }
                    else {
                        this.setState({ loading: false });
                        this.showNoti("Notification", json.Message == undefined ? global.Message.FailedSave : json.Message, "danger");
                    }

                })
                .catch(error => {
                    this.setState({ loading: false });
                });
        }
        else {
            this.setState({ loading: false });
            this.showNoti("Notification", global.Message.RequiredMessage, "danger");
        }
    }

    handleDownload = (e) => {

        this.setState({ loading: true });

        axios.get(global.Form121.DownloadPdfAPI + this.state.pdfLocation,
            {
                headers: { "Authorization": `Bearer ${localStorage.getItem('token')}`, 'Accept': 'application/pdf' },
                responseType: 'blob'
            })
            .then(response => {
                this.setState({ loading: false });
                this.showNoti("Notification", "File Downloaded Successfully", "success");

                const content = response.headers['content-type'];
                const fileName = this.state.uniqueNo + '.pdf'
                download(response.data, fileName, content)

            })
            .catch(error => {

                this.setState({ loading: false });
                this.showNoti("Notification", "Error Occurred While Downloading", "danger");
            });
    }

    handleSignDownload = (e) => {
        this.setState({ loading: true });
        axios.get(global.Form121.DownloadSignedPdfAPI + '?DigiPath=' + this.state.pdfLocation + '&UniqueNo=' + this.state.uniqueNo + '&AssignmentCode=' + this.state.assignmentCodes + '&DPID=' + this.state.DPIDs + '&emailID=' + this.state.emailID + '&PN=' + window.atob(this.state.PAN),
            {
                headers: { "Authorization": `Bearer ${localStorage.getItem('token')}`, 'Accept': 'application/pdf' },
                responseType: 'blob'
            })
            .then(response => {
                const content = response.headers['content-type'];
                const fileName = this.state.uniqueNo + '.pdf'
                download(response.data, fileName, content)
                this.setState({ loading: false });
                this.showNoti("Notification", "File Downloaded successfully", "success");
                setTimeout(() => {
                    if (this.state.IsOnlineOffline === "1") {
                        window.location.href = config.url.Web_URL;
                    }
                    else {
                        window.location.href = config.url.Web_URL + '/Resident/Dashboard?AC=' + window.btoa(this.state.AssignmentCode) + '&flag=' + window.btoa(0) + '&DP=' + window.btoa(this.state.DPID) + '&PN=' + window.btoa(this.state.PAN);
                    }
                }, 3000);
            })
            .catch(error => {
                this.setState({ loading: false });
            });
    }

    handleDigiSign = (e) => {

        this.handlesignPopup();


        axios.get(global.Form121.SignPdfAPI + this.state.pdfLocation + "&certificateNo=" + this.state.certificateNo + "&remitterCode=" + this.state.RemitterCode + "&DPID=" + this.state.DPID + "&beneficiaryName=" + this.state.beneficiaryName,
            {
                headers: { "Authorization": `Bearer ${localStorage.getItem('token')}` }
            })
            .then(response => {
                this.setState({ loading: false });

                const element = <div><input type='hidden' name='Parameter1' value={response.data["text"]} /><input type='hidden' name='Parameter2' value={response.data["encryptedData"]} /><input type='hidden' name='Parameter3' value={response.data["encryptHashData"]} /></div>;

                ReactDOM.render(element, document.getElementById('rootForm'));

                this.state.mainHtml = 'Done';
                this.state.mainHtmlCount = 1;
                this.setState((state, props) => ({ size: state.size + 10 }));


            })
            .catch(error => {
                this.setState({ loading: false });
            });
    }

    showNoti(title, message, type) {

        store.addNotification({
            title: title,
            message: message,
            type: type,
            insert: "top",
            container: "top-right",
            animationIn: ["animate__animated", "animate__fadeIn"],
            animationOut: ["animate__animated", "animate__fadeOut"],
            dismiss: {
                duration: 10000,
                onScreen: true
            }
        });

    };

    handelFileChange = event => {
        let file = event.target.files[0];
        var type = file.name.substring(file.name.lastIndexOf('.') + 1);
        var mimeType = file.type;
        if (mimeType == "application/pdf") {
            this.setState({ filesToBeSent: event.target.files[0] });
        }
        else {
            this.setState({ filesToBeSent: event.target.files[0] });
            this.showNoti("Notification", global.Message.PDFFormatRequiredMessage, "danger");
        }
    };

    handleAccept = (event) => {
        this.setState({ loading: true });
        event.preventDefault();

        const demoForm15GH = this.state;
        axios.post(global.Form121.AcceptForm121API, demoForm15GH,
            {
                headers: { "Authorization": `Bearer ${localStorage.getItem('token')}` }
            })
            .then(response => {
                if (response.status) {
                    this.showNoti("Notification", global.Message.SuccessMessage, "success");

                    this.setState({ loading: false, IsSubmitDisable: true, IsSaveDisable: true, IsESignDisable: true, time: {}, seconds: 900, isFirstClick: 1, activeTabID: 'hTabsIcons-4', hTabsIcons: 'hTabsIcons-4', IsSignCompleted: 1, IsStep4Enable: false, });


                } else {
                    this.setState({ loading: false });;
                    this.showNoti("Notification", response.Message, "danger");
                }

            })
            .catch(error => {
                this.setState({ loading: false, showLoaderModal: false });
            });
    };

    handleUploadClick = (event) => {

        this.setState({ loading: true });
        event.preventDefault();

        //var self = this;
        if (this.state.filesToBeSent !== "") {

            this.state.loading = true;

            var filesArray = this.state.filesToBeSent;
            let form = new FormData();
            var mimeType = filesArray.type;

            if (mimeType == "application/pdf") {

                form.append("File", filesArray);
                form.append("fileName", filesArray.name);
                form.append("certificateNo", this.state.certificateNo);
                form.append("remitterCode", this.state.RemitterCode);
                form.append("uniqueNo", this.state.uniqueNo);
                form.append("remitterName", this.state.remitterName);
                form.append("AssignmentCode", this.state.AssignmentCode);
                form.append("DPID", this.state.DPID);
                form.append("PAN", this.state.PAN);
                form.append("IsOnlineOffline", this.state.IsOnlineOffline);
                form.append("beneficiaryName", this.state.beneficiaryName);

                axios.post(global.Form121.UploadSignDoc, form,
                    { headers: { "Authorization": `Bearer ${localStorage.getItem('token')}` } })
                    .then(response => {
                        if (response.status) {
                            this.setState({ modal: false, file: '', filesToBeSent: '', fileName: '' });

                            this.showNoti("Notification", global.Message.SuccessMessage, "success");

                            this.setState({ loading: false, IsSubmitDisable: true, IsSaveDisable: true, IsESignDisable: true, time: {}, seconds: 900, isFirstClick: 1, activeTabID: 'hTabsIcons-4', hTabsIcons: 'hTabsIcons-4', IsSignCompleted: 1, IsStep4Enable: false, });


                        } else {
                            this.setState({ loading: false });;
                            this.showNoti("Notification", response.Message, "danger");
                        }
                    })
                    .catch(error => {
                        this.setState({ loading: false });
                    });
            }
            else {
                this.setState({ loading: false });
                this.showNoti("Notification", "Only .pdf files are valid.", "danger");
                return;
            }

        }
        else {
            this.setState({ loading: false });;
            this.showNoti("Notification", "File is not selected.", "danger");
        }
    }

    setHTabsIcons(name) {
        this.setState({ activeTabID: name, hTabsIcons: name });

    }

    handleCountryChanges(e) {
        let formErrors = {};
        let formIsValid = true;
        if (e.value == '') {
            formIsValid = false;
            formErrors["countryErr"] = "Please select Country";
        }
        else if (e.value == 78) {
            this.setState({ country: e.value, showDrStates: 'block', showTextStates: 'none' });
        } else {

            this.setState({ country: e.value, showDrStates: 'none', showTextStates: 'block' });

        }
    }

    handleAYID(e) {

        if (e.value != undefined) {
            this.setState({ latestAssessmentYearNew: this.state.AYIDs.find(obj => obj.value === e.value) });

        }
    }

    handleFYID(e) {
        let formErrors = {};
        let formIsValid = true;
        if (e.value == '') {
            formIsValid = false;
            formErrors["FYIDErr"] = "Please select Financial year.";
        }
        this.setState({ formErrors: formErrors, FYID: e.value, dividendDeclarationDate: 0 });

        return formIsValid;
    }

    handleStatus(e) {
        if (e.value != undefined) {
            this.setState({ status: e.label });
        }
    }

    handleRemitter(e) {
        if (e.value != undefined) {
            this.setState({
                remitterID: e.value,
                remitterName: e.label,
            });
        }
    }

    handleSections(e) {
        if (e.value != undefined) {
            this.setState({ sectionCode: e.label });
        }
    }

    handleStates(e) {
        if (e.value != undefined) {
            this.setState({ states: e.label });
        }
    }

    handleResStatus(e) {
        if (e.value != undefined) {
            this.setState({ residentialStatus: e.label });
        }
    }

    modalClose() {
        this.setState({
            file: "",
            modal: false
        });
    }

    modalCloseSave() {
        this.setState({
            showLoaderModal: false
        });
    }

    modalsignClose() {
        this.setState({
            showsignmodal: false
        });
    }

    handleAccessChange = (e) => {

        if (e.value == 0) {
            this.setState({ isAccessToTax: e.value, isLatestAYDisable: true, latestAssessmentYearNew: null });
        }
        else {
            this.setState({ isAccessToTax: e.value, isLatestAYDisable: false, latestAssessmentYearNew: null });
        }
    }

    handlePopup = (e) => {
        this.setState({ modal: true, file: '' });
    }

    handlesignPopup = (e) => {
        this.setState({ showsignmodal: true });
    }

    handleclose = (e) => {
        if (["P", "T", "H"].includes(this.state.PAN.substring(3, 4))) {
            axios.get(global.Form121.GetDetailsAPI + '?AssignmentCode=' + this.state.AssignmentCode + '&PAN=' + this.state.PAN + '&DPID=' + this.state.DPID)
                //{ headers: { "Authorization": `Bearer ${localStorage.getItem('token')}` } })
                .then(response => {
                    if (response.data.status) {
                        var CountOfForm15Op = '';

                        if (response.data.Form15GHDetails[0]["CountOfForm15"] == null) {
                            CountOfForm15Op = '';
                        }
                        else if (response.data.Form15GHDetails[0]["CountOfForm15"] == 0) {
                            CountOfForm15Op = '';
                        }
                        else {
                            CountOfForm15Op = response.data.Form15GHDetails[0]["CountOfForm15"];

                        }

                        var IsAccessToTaxOp = '';

                        if (response.data.Form15GHDetails[0]["IsAccessToTax"] == false) {
                            IsAccessToTaxOp = 0;
                        }
                        else if (response.data.Form15GHDetails[0]["IsAccessToTax"] == true) {
                            IsAccessToTaxOp = 1;
                        }
                        else {
                            IsAccessToTaxOp = ''
                        }

                        this.setState({
                            RemitterCode: response.data.Form15GHDetails[0]["RemitterCode"],
                            IsESign: response.data.Form15GHDetails[0]["IsESign"],
                            IsManualSign: response.data.Form15GHDetails[0]["IsManualSign"],
                            IsConsent: response.data.Form15GHDetails[0]["IsConsent"],
                            beneficiaryName: response.data.Form15GHDetails[0]["BeneficiaryName"],
                            remitterName: response.data.Form15GHDetails[0]["RemitterName"],
                            PAN: response.data.Form15GHDetails[0]["PAN"],
                            emailID: response.data.Form15GHDetails[0]["EmailID"],
                            dob: response.data.Form15GHDetails[0]["DOB"] == "1900-01-01" ? "" : response.data.Form15GHDetails[0]["DOB"],
                            premisesName: response.data.Form15GHDetails[0]["PremisesName"],
                            previousYear: response.data.Form15GHDetails[0]["PreviousYear"],
                            residentialStatus: response.data.Form15GHDetails[0]["ResidentialStatus"] === undefined ? 'Resident' : response.data.Form15GHDetails[0]["ResidentialStatus"],
                            flat: response.data.Form15GHDetails[0]["Flat"],
                            street: response.data.Form15GHDetails[0]["Street"],
                            area: response.data.Form15GHDetails[0]["Area"],
                            country: response.data.Form15GHDetails[0]["Country"],
                            city: response.data.Form15GHDetails[0]["City"],
                            country: response.data.Form15GHDetails[0]["CountryID"],
                            states: response.data.Form15GHDetails[0]["State"],
                            zipCode: response.data.Form15GHDetails[0]["ZipCode"],
                            stdCode: response.data.Form15GHDetails[0]["STDCode"],
                            status: response.data.Form15GHDetails[0]["Status"] == "" ? 'Individual' : response.data.Form15GHDetails[0]["Status"],
                            sectionCode: response.data.Form15GHDetails[0]["SectionCode"],
                            certificateNo: response.data.Form15GHDetails[0]["CertificateNo"],
                            uniqueNo: response.data.Form15GHDetails[0]["UniqueIdentificationNo"],
                            IsSubmitDisable: response.data.Form15GHDetails[0]["CertificateNo"] == "" ? true : false,
                            aggregateAmountIncome: response.data.Form15GHDetails[0]["AggregateAmountIncome"] == null ? '' : response.data.Form15GHDetails[0]["AggregateAmountIncome"],
                            datePaidIncome: response.data.Form15GHDetails[0]["DatePaidIncome"] == null ? '' : moment(response.data.Form15GHDetails[0]["DatePaidIncome"]).format('YYYY-MM-DD'),
                            estimateIncome: response.data.Form15GHDetails[0]["EstimateIncome"] == null ? '' : response.data.Form15GHDetails[0]["EstimateIncome"],
                            estimateTotalIncome: response.data.Form15GHDetails[0]["EstimateTotalIncome"] == null ? '' : response.data.Form15GHDetails[0]["EstimateTotalIncome"],
                            isAccessToTax: IsAccessToTaxOp,
                            countOfForm15: CountOfForm15Op,
                            mobileNo: response.data.Form15GHDetails[0]["MobileNo"] == null ? '' : response.data.Form15GHDetails[0]["MobileNo"],
                            telephoneNo: response.data.Form15GHDetails[0]["TelephoneNo"] == null ? 0 : response.data.Form15GHDetails[0]["TelephoneNo"],
                            latestAssessmentYearNew: response.data.Form15GHDetails[0]["AssessmentYear"] == null ? '' : response.data.Form15GHDetails[0]["AssessmentYear"],
                            latestAssessmentYear: response.data.Form15GHDetails[0]["AssessmentFYYear"] == null ? '' : response.data.Form15GHDetails[0]["AssessmentFYYear"],
                            paidIncome: response.data.Form15GHDetails[0]["PaidIncome"] == null ? '' : response.data.Form15GHDetails[0]["PaidIncome"],
                            buttonDisable: response.data.Form15GHDetails[0]["CertificateNo"] == null ? true : false,
                            pdfLocation: response.data.Form15GHDetails[0]["PDFLoc"] == null ? '' : response.data.Form15GHDetails[0]["PDFLoc"],
                            IsStep2Enable: response.data.Form15GHDetails[0]["CertificateNo"] == "" ? true : false,
                            IsStep3Enable: response.data.Form15GHDetails[0]["IsFillCompleted"] == 1 ? false : true,
                            IsStep4Enable: response.data.Form15GHDetails[0]["IsSignCompleted"] == 1 ? false : true,
                            IsSaveCompleted: response.data.Form15GHDetails[0]["CertificateNo"] == "" ? 0 : 1,
                            IsFillCompleted: response.data.Form15GHDetails[0]["IsFillCompleted"],
                            IsSignCompleted: response.data.Form15GHDetails[0]["IsSignCompleted"],
                            IsDownloadCompleted: response.data.Form15GHDetails[0]["IsDownloadCompleted"],
                            DigiPath: response.data.Form15GHDetails[0]["DigiPath"],
                            ManualPath: response.data.Form15GHDetails[0]["ManualPath"],
                            remitterID: response.data.Form15GHDetails[0]["RemitterID"],
                            countrycode: response.data.Form15GHDetails[0]["countrycode"],
                            abover60yearsold: response.data.Form15GHDetails[0]["abover60yearsold"].toString(),
                            otherform121filled: response.data.Form15GHDetails[0]["otherform121filled"].toString(),
                            taxYear1: response.data.Form15GHDetails[0]["taxyear1"],
                            ackNo1: response.data.Form15GHDetails[0]["ackno1"],
                            returnIncome1: response.data.Form15GHDetails[0]["returnincome1"],
                            taxYear2: response.data.Form15GHDetails[0]["taxyear2"],
                            ackNo2: response.data.Form15GHDetails[0]["ackno2"],
                            returnIncome2: response.data.Form15GHDetails[0]["returnincome2"],
                            taxYear: response.data.Form15GHDetails[0]["taxyear"] !== "" && response.data.Form15GHDetails[0]["taxyear"] !== null ? response.data.Form15GHDetails[0]["taxyear"] : this.state.taxYear
                        })

                        if (response.data.Form15GHDetails[0]["EmailID"] == "" || response.data.Form15GHDetails[0]["EmailID"] == null) {
                            this.setState({
                                isEmailDisabled: false
                            });
                        }
                        else {
                            this.setState({
                                isEmailDisabled: true
                            });
                        }

                        if (response.data.Form15GHDetails[0]["RemitterName"] == "" || response.data.Form15GHDetails[0]["RemitterName"] == null) {
                            this.setState({
                                isRemitterDisable: false
                            });
                        }
                        else {
                            this.setState({
                                isRemitterDisable: true
                            });
                        }

                        if (response.data.Form15GHDetails[0]["BeneficiaryName"] == "" || response.data.Form15GHDetails[0]["BeneficiaryName"] == null) {
                            this.setState({
                                isbeneficiaryNameDisable: false
                            });
                        }
                        else {
                            this.setState({
                                isbeneficiaryNameDisable: true
                            });
                        }

                        if (response.data.Form15GHDetails[0]["PAN"] == "" || response.data.Form15GHDetails[0]["PAN"] == null) {
                            this.setState({
                                isPanDisable: false
                            });
                        }
                        else {
                            this.setState({
                                isPanDisable: true
                            });
                        }

                        if (response.data.Form15GHDetails[0]["Status"] == "" || response.data.Form15GHDetails[0]["Status"] == null) {
                            this.setState({
                                isStatusDisable: false
                            });
                        }
                        else {
                            this.setState({
                                isStatusDisable: true
                            });
                        }
                        if (response.data.Form15GHDetails[0]["PreviousYear"] == "" || response.data.Form15GHDetails[0]["PreviousYear"] == null) {
                            this.setState({
                                isPreviousYearDisabled: false
                            });
                        }
                        else {
                            this.setState({
                                isPreviousYearDisabled: true
                            });
                        }
                        if (response.data.Form15GHDetails[0]["ResidentialStatus"] == "" || response.data.Form15GHDetails[0]["ResidentialStatus"] == null) {
                            this.setState({
                                isresStatusDisabled: false
                            });
                        }
                        else {
                            this.setState({
                                isresStatusDisabled: true
                            });
                        }

                        if (this.state.IsSaveCompleted == 1) {
                            axios.get(global.Form121.DownloadPdfBase64API + this.state.pdfLocation,
                                {
                                    headers: { "Authorization": `Bearer ${localStorage.getItem('token')}` }
                                })
                                .then(response => {
                                    this.setState({ base64Data: decodeURIComponent(response.data), showModal: true });

                                })
                                .catch(error => {
                                    this.showNoti("Notification", "Unable to Load Declaration", "danger");
                                });
                        }


                        if (this.state.isAccessToTax == 1)
                            this.setState({ showAsessmentYr: 'block', isLatestAYDisable: false, latestAssessmentYearNew: { value: this.state.latestAssessmentYearNew, label: this.state.latestAssessmentYear } });

                        if (this.state.IsFillCompleted == 1) {
                            this.setState({ IsSubmitDisable: true, IsSaveDisable: true });
                        }

                        if (this.state.IsSignCompleted == 1) {
                            this.setState({ IsSubmitDisable: true, IsSaveDisable: true, IsESignDisable: true });
                        }


                        if (this.state.isFirstClick == 0) {
                            this.timer = setInterval(this.countDown, 1000);
                            this.setState({ loading: false, time: {}, seconds: 900, isFirstClick: 1 });
                        }
                        else {
                            this.setState({ loading: false, time: {}, seconds: 900, isFirstClick: 1 });
                        }
                    }
                    else {
                        window.location.href = config.url.Web_URL;
                    }
                })
                .catch(error => {
                    this.setState({ loading: false });;
                });
            axios.get(global.Form121.GetTaxLimitAPI + '?AssignmentCode=' + this.state.AssignmentCode)
                .then(response => {
                    if (response.data.status) {
                        this.setState({
                            Limit: response.data.Form15GHDetails[0]["TaxLimit"],
                            LimitH: response.data.Form15GHDetails[0]["TaxLimitH"]
                        })
                    }
                    else {
                        window.location.href = config.url.Web_URL;
                    }

                }).catch(error => {
                    this.setState({ loading: false });
                });

            window.location.href = config.url.Web_URL + '/Resident/Dashboard?AC=' + window.btoa(this.state.AssignmentCode) + '&flag=' + window.btoa(0) + '&DP=' + window.btoa(this.state.DPID) + '&PN=' + window.btoa(this.state.PAN);
        }
    }

    HandelNavigateURL = (e) => {
        window.location.href = config.url.Web_URL + '/Resident/Dashboard?AC=' + window.btoa(this.state.AssignmentCode) + '&flag=' + window.btoa(0) + '&DP=' + window.btoa(this.state.DPID) + '&PN=' + window.btoa(this.state.PAN);

        if (this.state.StageID == 0) {
            this.setState({ activeTabID: 'hTabsIcons-1', hTabsIcons: 'hTabsIcons-1' });
        }
        else if (this.state.StageID == 1) {
            this.setState({ activeTabID: 'hTabsIcons-1', hTabsIcons: 'hTabsIcons-1' });
        }
        else if (this.state.StageID == 2) {
            this.setState({ activeTabID: 'hTabsIcons-2', hTabsIcons: 'hTabsIcons-2' });
        }
        else if (this.state.StageID == 3) {
            this.setState({ activeTabID: 'hTabsIcons-3', hTabsIcons: 'hTabsIcons-3' });
        }
        else if (this.state.StageID == 4) {
            this.setState({ activeTabID: 'hTabsIcons-4', hTabsIcons: 'hTabsIcons-4' });
        }
    }

    handleCountryCode(e) {
        if (e.value != undefined) {
            this.setState({ countrycode: e.label });
        }
    }

    handleOtherFormsFilled(e) {
        if (e.value != undefined) {
            this.setState({ otherform121filled: e.value });
        }
    }

    handleAbover60Years(e) {
        if (e.value != undefined) {
            this.setState({ abover60yearsold: e.value });

            if (e.value==='1') {
                this.state.FinalLimit = this.state.LimitH;
            }
            else {
                this.state.FinalLimit = this.state.Limit;
            }
        }
    }

    handlePrevTwoYears(e) {
        if (e.value != undefined) {
            this.setState({ taxYear1: e.value });
            let t1 = e.value.split('-');
            let y1 = parseInt(t1[0])
            let y2 = parseInt(t1[1])
            this.setState({ taxYear2: (y1-1)+'-'+(y2-1) });

        }
    }


    render() {
        if (this.state.loading) return <Spinner />;
        const { DOBErr, previousYearErr, assessmentYearErr, estimateIncomeErr, estimateTotalIncomeErr, paidIncomeErr, datePaidIncomeErr, mobileNoErr,
            residentialStatusErr, cityErr, areaErr, FYIDErr, stateErr, countryErr, dividendDeclarationDateErr, flatErr, zipCodeErr, aggregateAmountIncomeErr, otherform121fillederr, countrycodeerr, above60yearsolderr } = this.state.formErrors;
        const {
            isClearable,
            isSearchable
        } = this.state;

        let content = Layout.RenderNavMenu();
        let contentFooter = Layout.RenderFooter();

        return (

            <div>
                <ReactNotification />
                {content}
                <div className="m-grid__item m-grid__item--fluid m-wrapper">
                    <div className="Nexdigm">
                        <ol className="breadcrumb btn-Nexdigm">
                            <li><span onClick={this.HandelNavigateURL} className="text-white" style={{ cursor: 'pointer' }}><FontAwesomeIcon icon="home" /> Home</span></li>
                            {/*<li><a href={this.state.url} className="text-white"><FontAwesomeIcon icon="home" /> Home</a></li>*/}
                            <li><a href={this.state.url + "Resident/Form121"} className="text-white">Form 121</a></li>
                        </ol>
                    </div>
                    <Modal isOpen={this.state.modal} toggle={e => this.modalClose(e)} size="md">
                        <ModalHeader toggle={this.handleCloseModal}>Declaration Form</ModalHeader>
                        <ModalBody>
                            <Row>
                                <Col md={12}>
                                    <input type="file" name="files" multiple onChange={this.handelFileChange} />
                                </Col>
                            </Row>

                        </ModalBody>
                        <ModalFooter>
                            <button className="btn btn-success" type="button" onClick={this.handleUploadClick}>Upload</button>
                            <button className="btn btn-dark m-l-10" type="button" onClick={e => this.modalClose(e)}>Cancel</button>
                        </ModalFooter>
                    </Modal>

                    <Modal isOpen={this.state.showsignmodal} toggle={e => this.modalsignClose(e)} size="lg"
                        aria-labelledby="contained-modal-title-vcenter"
                        centered>

                        <ModalBody>
                            <Row>
                                <Col md={12} className="session-modal-text">
                                    <strong>Kindly wait; you are redirected to electronic signing page</strong>
                                </Col>
                            </Row>
                        </ModalBody>
                    </Modal>

                    <Modal isOpen={this.state.showLoaderModal} size="lg"
                        aria-labelledby="contained-modal-title-vcenter"
                        centered>
                        <ModalBody>
                            <Row>
                                <Col md={12} className="session-modal-text">
                                    {this.state.loaderText}
                                </Col>
                            </Row>
                        </ModalBody>
                        <ModalFooter style={{
                            display: `${this.state.isLoaderButtonEnable}`, textAlign: "center"
                        }}>
                            <button className="btn btn-success" type="button" onClick={this.handlePreviewSubmit}>Submit</button>
                            <button className="btn btn-dark m-l-10" type="button" onClick={e => this.modalCloseSave(e)}>Cancel</button>
                        </ModalFooter>

                    </Modal>
                    <Modal isOpen={this.state.isYesOpen} size="lg" aria-labelledby="contained-modal-title-vcenter" centered>
                        <ModalHeader charCode="X">Disclaimer</ModalHeader>
                        <ModalBody>
                            <Row>
                                <Col md={12} className="session-modal-text">
                                    Dear Shareholder, you have already submitted a declaration previously for same financial year. If you wish to submit a revised declaration, please ensure that the amount entered in the Sr. No. 16 ‘ Estimated Income for which Declaration is made’ and Sr. No. 17 ‘ Estimated Total Income for the year’ is sufficient to cover the total dividend earned by you during the entire year.
                                </Col>
                            </Row>

                        </ModalBody>
                        <ModalFooter>
                            <button className="btn btn-success" type="button" onClick={this.handleSubmit2}>Proceed</button>
                            <button className="btn btn-dark m-l-10" type="button" onClick={this.closeYesModal}>Cancel</button>
                        </ModalFooter>
                    </Modal>
                    <div className="content-page">
                        <div className="card">
                            <div className="card-body">
                                <div className="nav-wrapper">
                                    <Nav className="nav-fill flex-column flex-md-row" pills role="tablist">
                                        <NavItem>
                                            <NavLink className={(this.state.IsSaveCompleted == "1" ? "bg-success" : "bg-warning") + " " + (this.state.hTabsIcons === "hTabsIcons-1" ? "active" : "")} href="#pablo"
                                                onClick={(e) => {
                                                    e.preventDefault();
                                                    this.setHTabsIcons("hTabsIcons-1");
                                                }}>
                                                {(this.state.IsSaveCompleted == "1" ? "" : "")} 1. Fill Form 121 Declaration </NavLink>
                                        </NavItem>
                                        <NavItem>
                                            <NavLink disabled={this.state.IsStep2Enable} className={(this.state.IsFillCompleted == "1" ? "bg-success" : (this.state.IsSaveCompleted == "1" ? "bg-warning" : "bg-dark")) + "  " + (this.state.hTabsIcons === "hTabsIcons-2" ? "active" : "")} href="#pablo" onClick={(e) => {
                                                e.preventDefault();
                                                this.setHTabsIcons("hTabsIcons-2");
                                            }}>
                                                {(this.state.IsFillCompleted == "1" ? "" : "")} 2. Preview Form 121 Declaration </NavLink>


                                        </NavItem>
                                        <NavItem>
                                            <NavLink disabled={this.state.IsStep3Enable} className={(this.state.IsSignCompleted == "1" ? "bg-success" : (this.state.IsFillCompleted == "1" ? "bg-warning" : "bg-dark")) + "  " + (this.state.hTabsIcons === "hTabsIcons-3" ? "active" : "")} href="#pablo" onClick={(e) => {
                                                e.preventDefault();
                                                this.setHTabsIcons("hTabsIcons-3");
                                            }}>
                                                {(this.state.IsSignCompleted == "1" ? "" : "")} 3. Sign Form 121 Declaration </NavLink>


                                        </NavItem>
                                        <NavItem>
                                            <NavLink disabled={this.state.IsStep4Enable} className={(this.state.IsDownloadCompleted == "1" ? "bg-success" : (this.state.IsSignCompleted == "1" ? "bg-warning" : "bg-dark")) + "  " + (this.state.hTabsIcons === "hTabsIcons-4" ? "active" : "")} href="#pablo" onClick={(e) => {
                                                e.preventDefault();
                                                this.setHTabsIcons("hTabsIcons-4");
                                            }}>
                                                {(this.state.IsDownloadCompleted == "1" ? "" : "")} 4. Download Form 121 Declaration </NavLink>

                                        </NavItem>
                                    </Nav>
                                </div>
                                <TabContent id="myTabContent" activeTab={this.state.activeTabID}>
                                    <TabPane tabId="hTabsIcons-1" role="tabpanel">
                                        <div className="card m-t-10" >
                                            <div className="card-body">
                                                <h4 className="header-title text-center">Fill Form 121 Declaration</h4>
                                                <Row>
                                                    <Col md={4}>
                                                        <label htmlFor="remitterName" className="required-field">Remitter</label>
                                                        <InputGroup className="mb-3 m-t-10">
                                                            <FormControl type="text" name="remitterName" maxLength="250"
                                                                value={this.state.remitterName}
                                                                onChange={this.handleChange} disabled />
                                                        </InputGroup>
                                                    </Col>

                                                    <Col md={4}>
                                                        <label htmlFor="beneficiaryName" className="required-field">Name of Assessee (Declarant)</label>
                                                        <InputGroup className="mb-3 m-t-10">
                                                            <FormControl type="text" name="beneficiaryName"
                                                                value={this.state.beneficiaryName} maxLength="125"
                                                                onChange={this.handleChange} disabled />
                                                        </InputGroup>
                                                    </Col>
                                                    <Col md={4}>
                                                        <label htmlFor="PAN" className="required-field">PAN of the Assessee</label>
                                                        <InputGroup className="mb-3 m-t-10">
                                                            <FormControl type="text" name="PAN"
                                                                value={this.state.PAN} maxLength="10"
                                                                onChange={this.handleChange}
                                                                disabled={this.state.IsPanDisable} />
                                                        </InputGroup>
                                                    </Col>
                                                    <Col md={4} className="m-t-10 cursor-not-allowed-disable-dropdown">
                                                        <label htmlFor="status" className="required-field">Status</label>
                                                        <Select
                                                            className="basic-single"
                                                            classNamePrefix="select status"
                                                            value={this.state.statusDr.find(obj => obj.label === this.state.status)}
                                                            options={this.state.statusDr}
                                                            onChange={this.handleStatus.bind(this)}
                                                            isDisabled={true} />

                                                    </Col>
                                                    <Col md={4} className="m-t-10">
                                                        <label htmlFor="previousYear" >Tax Year</label>
                                                        <InputGroup className="mb-3 m-t-10">
                                                            <FormControl type="text" name="previousYear"
                                                                value={this.state.taxYear}
                                                                disabled />
                                                        </InputGroup>
                                                        {previousYearErr &&
                                                            <div className="Mont-Font">{previousYearErr}</div>
                                                        }
                                                    </Col>
                                                    <Col md={4} className="m-t-10 cursor-not-allowed-disable-dropdown">
                                                        <label htmlFor="resStatus" className="required-field">Residential Status</label>
                                                        <Select
                                                            className=" basic-single"
                                                            classNamePrefix="Select Residential Status"
                                                            value={this.state.resStatus.find(obj => obj.label === this.state.residentialStatus)}
                                                            options={this.state.resStatus}
                                                            onChange={this.handleResStatus.bind(this)}
                                                            isDisabled={true} />
                                                        {residentialStatusErr &&
                                                            <div className="Mont-Font">{residentialStatusErr}</div>
                                                        }
                                                    </Col>
                                                    <Col md={4} className="m-t-10">
                                                        <label htmlFor="flat" className="required-field">Flat/Door/Block No.</label>
                                                        <InputGroup className="mb-3 m-t-10">
                                                            <FormControl type="text" name="flat"
                                                                value={this.state.flat} maxLength="50"
                                                                onChange={this.handleChange}
                                                                placeholder= "Enter Flat/Door/Block No."
                                                            />
                                                        </InputGroup>
                                                        {flatErr &&
                                                            <div className="Mont-Font">{flatErr}</div>
                                                        }
                                                    </Col>
                                                    <Col md={4} className="m-t-10">
                                                        <label htmlFor="premisesName">Name of Premises</label>
                                                        <InputGroup className="mb-3 m-t-10">
                                                            <FormControl type="text" name="premisesName"
                                                                value={this.state.premisesName} maxLength="50"
                                                                onChange={this.handleChange}
                                                                placeholder="Enter Name of Premises"
                                                            />
                                                        </InputGroup>
                                                    </Col>

                                                    <Col md={4} className="m-t-10">
                                                        <label htmlFor="street" >Road/Street/Lane</label>
                                                        <InputGroup className="mb-3 m-t-10">
                                                            <FormControl type="text" name="street" maxLength="50"
                                                                value={this.state.street}
                                                                onChange={this.handleChange}
                                                                placeholder="Enter Road/Street/Lane"
                                                            />
                                                        </InputGroup>
                                                    </Col>
                                                    <Col md={4} className="m-t-10">
                                                        <label htmlFor="area" className="required-field">Area/Locality</label>
                                                        <InputGroup className="mb-3 m-t-10">
                                                            <FormControl type="text" name="area"
                                                                value={this.state.area} maxLength="50"
                                                                onChange={this.handleChange}
                                                                placeholder="Enter Area/Locality"
                                                            />
                                                        </InputGroup>
                                                        {areaErr &&
                                                            <div className="Mont-Font">{areaErr}</div>
                                                        }
                                                    </Col>
                                                    <Col md={4} className="m-t-10">
                                                        <label htmlFor="city" className="required-field">Town/City/District</label>
                                                        <InputGroup className="mb-3 m-t-10">
                                                            <FormControl type="text" name="city"
                                                                value={this.state.city} maxLength="50"
                                                                onChange={this.handleChange}
                                                                placeholder="Enter Town/City/District"
                                                            />
                                                        </InputGroup>
                                                        {cityErr &&
                                                            <div className="Mont-Font">{cityErr}</div>
                                                        }
                                                    </Col>

                                                    <Col md={4} className="m-t-10">
                                                        <label htmlFor="state" className="required-field">State</label>
                                                        <Select
                                                            className="mb-3 basic-single"
                                                            classNamePrefix="Select State"
                                                            value={this.state.drStates.find(obj => obj.label === this.state.states)}
                                                            isSearchable={isSearchable}
                                                            options={this.state.drStates}
                                                            onChange={this.handleStates.bind(this)}
                                                        />
                                                        {stateErr &&
                                                            <div className="Mont-Font">{stateErr}</div>
                                                        }
                                                    </Col>

                                                    <Col md={4} className="m-t-10">
                                                        <label htmlFor="zipCode" className="required-field">PIN</label>
                                                        <InputGroup className="mb-3 m-t-10">
                                                            <FormControl type="number"
                                                                maxLength={6} name="zipCode"
                                                                value={this.state.zipCode}
                                                                onChange={this.handleNumericChange}
                                                                placeholder="Enter PIN"
                                                            />
                                                        </InputGroup>
                                                        {zipCodeErr &&
                                                            <div className="Mont-Font">{zipCodeErr}</div>
                                                        }
                                                    </Col>

                                                    <Col md={4} className="m-t-10">
                                                        <label htmlFor="emailID" className="required-field">Email</label>
                                                        <InputGroup className="mb-3 m-t-10">
                                                            <FormControl type="text" name="emailID" maxLength="125"
                                                                value={this.state.emailID}
                                                                onChange={this.handleChange}
                                                                placeholder="Enter email"
                                                            />
                                                        </InputGroup>
                                                    </Col>
                                                   
                                                    <Col md={4} className="m-t-10">
                                                        <label htmlFor="abover60yearsold" className="required-field">Whether age is 60 years or more</label>
                                                        <Select
                                                            className="mb-3 basic-single"
                                                            name="abover60yearsold"
                                                            classNamePrefix="Select"
                                                            value={yesnooptions.find(obj => obj.value === this.state.abover60yearsold)}
                                                            isSearchable={isSearchable}
                                                            options={yesnooptions}
                                                            onChange={this.handleAbover60Years.bind(this)}
                                                            isDisabled={true}
                                                        />
                                                        {above60yearsolderr &&
                                                            <div className="Mont-Font">{above60yearsolderr}</div>
                                                        }
                                                    </Col>
                                                    <Col md={4} className="m-t-10">
                                                        <label htmlFor="dob" className="required-field">Date of Birth</label>
                                                        <InputGroup className="mb-3 m-t-10">
                                                            <input type="date" name="dob"
                                                                value={this.state.dob}
                                                                className="input1001"
                                                                onChange={this.handleChange}
                                                                placeholder="DD-MMM-YYYY"
                                                            />
                                                        </InputGroup>
                                                        {DOBErr &&
                                                            <div className="Mont-Font">{DOBErr}</div>
                                                        }

                                                    </Col>
                                                    {/*<Col md={4} className="m-t-10">*/}
                                                    {/*    <label htmlFor="telephoneNo">Telephone No (With STD Code)</label>*/}
                                                    {/*    <InputGroup className="mb-3 m-t-10">*/}
                                                    {/*        <FormControl type="number" name="telephoneNo"*/}
                                                    {/*            value={this.state.telephoneNo} maxLength="15"*/}
                                                    {/*            onChange={this.handleNumericChange} />*/}
                                                    {/*    </InputGroup>*/}
                                                    {/*</Col>*/}
                                                    <Col md={2} className="m-t-10">
                                                        <label htmlFor="countryCode" className="required-field">Country Code</label>
                                                        <Select
                                                            className="mb-3 basic-single"
                                                            classNamePrefix="Select State"
                                                            value={this.state.drcountrycode.find(obj => obj.label === this.state.countrycode)}
                                                            isSearchable={isSearchable}
                                                            options={this.state.drcountrycode}
                                                            onChange={this.handleCountryCode.bind(this)}
                                                        />
                                                        {countrycodeerr &&
                                                            <div className="Mont-Font">{countrycodeerr}</div>
                                                        }
                                                    </Col>
                                                    <Col md={4} className="m-t-10">
                                                        <label htmlFor="mobileNo" className="required-field">Mobile No</label>
                                                        <InputGroup className="mb-3 m-t-10">
                                                            <FormControl type="number" name="mobileNo"
                                                                value={this.state.mobileNo} maxLength="10"
                                                                onChange={this.handleNumericChange}
                                                                placeholder="Enter mobile no."
                                                            />
                                                        </InputGroup>
                                                        {mobileNoErr &&
                                                            <div className="Mont-Font">{mobileNoErr}</div>
                                                        }
                                                    </Col>

                                                    {/*<Col md={4} className="m-t-10">*/}
                                                    {/*    <label htmlFor="isAccessToTax" className="required-field">Whether assessed to tax under the Income-tax Act, 1961</label>*/}
                                                    {/*    <Select*/}
                                                    {/*        className="basic-single"*/}
                                                    {/*        value={this.state.isAccessToTaxDr.find(obj => obj.value === this.state.isAccessToTax)}*/}
                                                    {/*        options={this.state.isAccessToTaxDr}*/}
                                                    {/*        onChange={this.handleAccessChange.bind(this)} />*/}
                                                    {/*</Col>*/}
                                                    {/*<Col md={4} className={"m-t-10 " + (this.state.isLatestAYDisable ? "cursor-not-allowed-disable-dropdown" : "")}>*/}
                                                    {/*    <label htmlFor="assessmentYear" className="required-field">If yes, select latest assessment year for which assessed</label>*/}
                                                    {/*    <Select*/}
                                                    {/*        className={"basic-single " + (this.state.isLatestAYDisable? "disabled":"")}*/}
                                                    {/*        value={this.state.latestAssessmentYearNew}*/}
                                                    {/*        options={this.state.AYIDs}*/}
                                                    {/*        onChange={this.handleAYID.bind(this)}*/}
                                                    {/*        isDisabled={this.state.isLatestAYDisable}*/}
                                                    {/*    />*/}

                                                    {/*    {assessmentYearErr &&*/}
                                                    {/*        <div className="Mont-Font">{assessmentYearErr}</div>*/}
                                                    {/*    }*/}
                                                    {/*</Col>*/}
                                                    <Row>
                                                    <Col md={4} className="m-t-10">
                                                        <label htmlFor="estimateIncome" className="required-field">Estimated income for which this declaration is made</label>
                                                        <InputGroup className="mb-3 m-t-10">
                                                            <FormControl type="number" name="estimateIncome"
                                                                maxLength="14" value={this.state.estimateIncome}
                                                                onChange={this.handleNumericChange}
                                                                placeholder="Enter estimated income"
                                                            />
                                                        </InputGroup>
                                                        {estimateIncomeErr &&
                                                            <div className="Mont-Font">{estimateIncomeErr}</div>
                                                        }
                                                    </Col>
                                                    <Col md={8} className="m-t-10">
                                                        <label htmlFor="estimateTotalIncome" className="required-field">Estimated total income of the FY in which Estimated income for which this declaration is made to be included</label>
                                                        <InputGroup className="mb-3 m-t-10">
                                                            <FormControl type="number" name="estimateTotalIncome"
                                                                maxLength="14" value={this.state.estimateTotalIncome}
                                                                onChange={this.handleNumericChange}
                                                                placeholder="Enter total income"
                                                            />
                                                        </InputGroup>
                                                        {estimateTotalIncomeErr &&
                                                            <div className="Mont-Font">{estimateTotalIncomeErr}</div>
                                                        }
                                                    </Col>
                                                    </Row>

                                                    <Row>
                                                    <Col md={7} className="m-t-10">
                                                        <label htmlFor="aggregateAmountIncome" className="m-t-10 text-success text-bold f-18">Details of Form No 121 other than this form filled during the tax year, if any:</label>
                                                    </Col>
                                                    <Col md={2} className="m-t-10">
                                                            <Select
                                                                name="otherform121filled"
                                                            className="mb-3 basic-single"
                                                                classNamePrefix="Select State"
                                                                value={yesnooptions.find(obj => obj.value === this.state.otherform121filled)}
                                                            isSearchable={isSearchable}
                                                                options={yesnooptions}
                                                                onChange={this.handleOtherFormsFilled.bind(this)}
                                                        />
                                                        {otherform121fillederr &&
                                                                <div className="Mont-Font">{ otherform121fillederr }</div>
                                                        }
                                                        </Col>
                                                        <Col md={3} className="m-t-10">
                                                        </Col>
                                                    </Row>
                                                    {
                                                        this.state.otherform121filled === '1' &&
                                                        <Row>
                                                            <Col md={4} className="m-t-10">
                                                                <label htmlFor="countOfForm15" >Total No. of Form No. 121 filed</label>
                                                                <InputGroup className="mb-3 m-t-10">
                                                                    <FormControl type="number" name="countOfForm15"
                                                                        maxLength="2" value={this.state.countOfForm15}
                                                                        onChange={this.handleNumericChange}
                                                                        placeholder="Enter total no. of form"
                                                                    />
                                                                </InputGroup>
                                                            </Col>
                                                            <Col md={8} className="m-t-10">
                                                                <label htmlFor="aggregateAmountIncome">Aggregate amount of income for which Form No 121 filed</label>
                                                                <InputGroup className="mb-3 m-t-10">
                                                                    <FormControl type="number" name="aggregateAmountIncome"
                                                                        maxLength="14" value={this.state.aggregateAmountIncome}
                                                                        onChange={this.handleNumericChange}
                                                                        placeholder="Enter aggregate amount"
                                                                    />
                                                                </InputGroup>
                                                                {aggregateAmountIncomeErr &&
                                                                    <div className="Mont-Font">{aggregateAmountIncomeErr}</div>
                                                                }
                                                            </Col>
                                                        </Row>
                                                    }
                                                    
                                                    <Col md={12} className="m-t-10 text-bold">
                                                        <label className="m-t-10 text-success f-18">Details of income for which the declaration is filled:</label>
                                                    </Col>

                                                    <Col md={4} className="m-t-10">
                                                        <label className="required-field">Nature of Income</label>
                                                        <InputGroup className="mb-3 m-t-10">
                                                            <FormControl type="text"
                                                                value="Interest" disabled />
                                                        </InputGroup>
                                                    </Col>

                                                    <Col md={4} className="m-t-10">
                                                        <label className="required-field">Section under which the tax is deductible</label>
                                                        <InputGroup className="mb-3 m-t-10">
                                                            <FormControl type="text"
                                                                value="Section 393(1) [Table: Sl. No. 5(i), (ii) and (iii)]" disabled />
                                                        </InputGroup>
                                                    </Col>

                                                    <Col md={4} className="m-t-10">
                                                        <label htmlFor="paidIncome" className="required-field">Amount of income paid</label>
                                                        <InputGroup className="mb-3 m-t-10">
                                                            <FormControl type="number" name="paidIncome"
                                                                maxLength="8" value={this.state.paidIncome}
                                                                onChange={this.handleNumericChange}
                                                                placeholder="Enter amount of income paid"
                                                                disabled={true}
                                                            />
                                                        </InputGroup>
                                                        {paidIncomeErr &&
                                                            <div className="Mont-Font">{paidIncomeErr}</div>
                                                        }
                                                    </Col>
                                                    <Col md={12} className="m-t-10 text-bold">
                                                        <label className="m-t-10 text-success f-18"> Details of last of the ITR filed for previous two tax years:</label>
                                                    </Col>
                                                   
                                                    <Row>
                                                        <Col md={12} className="m-t-10">
                                                            <table style={tablestyles.table} >
                                                            <thead>
                                                                <tr>
                                                                    <th style={tablestyles.header}>Sl. No.</th>
                                                                    <th style={tablestyles.header}>Tax Year</th>
                                                                    <th style={tablestyles.header}>Acknowledgment Number</th>
                                                                    <th style={tablestyles.header} >Return Income</th>
                                                                </tr>
                                                            </thead>

                                                            <tbody>
                                                                <tr>
                                                                        <td style={tablestyles.cell}>1</td>

                                                                        <td style={tablestyles.cell}>
                                                                            <Select
                                                                                className="mb-3 basic-single"
                                                                                classNamePrefix="Select State"
                                                                                value={this.state.drPrevTwoyears.find(obj => obj.label === this.state.taxYear1)}
                                                                                isSearchable={isSearchable}
                                                                                options={this.state.drPrevTwoyears}
                                                                                onChange={this.handlePrevTwoYears.bind(this)}
                                                                            />
                                                                    </td>

                                                                        <td style={tablestyles.cell}>
                                                                        <input
                                                                            class="form-control"
                                                                            type="number"
                                                                            name="ackNo1"
                                                                            value={this.state.ackNo1}
                                                                            onChange={this.handleNumericChange}
                                                                            maxLength={15}
                                                                        />
                                                                    </td>

                                                                        <td style={tablestyles.cell}>
                                                                        <input
                                                                            class="form-control"
                                                                            type="number"
                                                                            name="returnIncome1"
                                                                            value={this.state.returnIncome1}
                                                                            onChange={this.handleChange}
                                                                        />
                                                                    </td>
                                                                </tr>

                                                                <tr>
                                                                        <td style={tablestyles.cell}>2</td>

                                                                        <td style={tablestyles.cell}>
                                                                        <input
                                                                            class="form-control"
                                                                            type="text"
                                                                            name="taxYear2"
                                                                            value={this.state.taxYear2}
                                                                                onChange={this.handleNumericChange}
                                                                            disabled={true}

                                                                        />
                                                                    </td>

                                                                        <td style={tablestyles.cell}>
                                                                        <input
                                                                            class="form-control"
                                                                            type="number"
                                                                            name="ackNo2"
                                                                            value={this.state.ackNo2}
                                                                                onChange={this.handleNumericChange}
                                                                            maxLength={15}
                                                                        />
                                                                    </td>

                                                                        <td style={tablestyles.cell}>
                                                                        <input
                                                                            class="form-control"
                                                                            type="number"
                                                                            name="returnIncome2"
                                                                            value={this.state.returnIncome2}
                                                                            onChange={this.handleChange}
                                                                        />
                                                                    </td>
                                                                </tr>
                                                            </tbody>
                                                            </table>
                                                        </Col>
                                                    </Row>
                                                    <Col md={12}>
                                                        <div className="m-t-10">
                                                            <button className="btn btn-danger m-l-10 pull-right m-t-15" onClick={this.handleclose}> Close </button>
                                                            <button disabled={this.state.IsSaveDisable} className="btn btn-success m-l-10 pull-right m-t-15" onClick={this.handleSubmit}> Save </button>
                                                        </div>
                                                    </Col>
                                                </Row>
                                            </div>
                                        </div>
                                    </TabPane>
                                    <TabPane tabId="hTabsIcons-2" role="tabpanel">
                                        <div className="card m-t-10" >
                                            <div className="card-body">
                                                <h4 className="header-title text-center">Preview Form 121 Declaration</h4>
                                                <Row>
                                                    <Col md={12}>
                                                        <button disabled={this.state.IsSubmitDisable} className="btn btn-primary m-l-10 pull-right m-t-15" onClick={this.handleOpenPopUp}> Submit & Sign</button>
                                                    </Col>
                                                    <Col md={12}>
                                                        <FilePreviewer
                                                            file={{
                                                                data: this.state.base64Data,
                                                                mimeType: 'application/pdf',
                                                                name: this.state.uniqueNo + '.pdf'// for download
                                                            }}
                                                        />
                                                    </Col>

                                                </Row>
                                            </div>
                                        </div>
                                    </TabPane>
                                    <TabPane tabId="hTabsIcons-3" role="tabpanel">
                                        <div className="card m-t-10" >
                                            <div className="card-body">

                                                <form name='PostForm' id="rootForm" ref="myFoo" method='POST' action='https://gateway-core.emsigner.com/Secure/index' onSubmit={this.handleOnAutoSubmit}>
                                                </form>
                                                <h4 className="header-title text-center">Sign Form 121 Declaration</h4>
                                                <Accordion defaultActiveKey={`${this.state.IsESign == 1 ? '0' : (this.state.IsManualSign == 1 ? '1' : '2')}`}>
                                                    <Accordion.Item eventKey="0" style={{ display: `${this.state.IsESign == 1 ? 'block' : 'none'}` }}>
                                                        <Accordion.Header>Sign Document Electronically</Accordion.Header>
                                                        <Accordion.Body>
                                                            <label className="m-t-25">Choose your Digital Signing Options</label><br />
                                                            <button disabled={this.state.IsESignDisable} className="btn btn-success m-t-10 h-40" onClick={this.handleDigiSign}>Electronic Sign</button>
                                                        </Accordion.Body>
                                                    </Accordion.Item>
                                                    <Accordion.Item eventKey="1" style={{ display: `${this.state.IsManualSign == 1 ? 'block' : 'none'}` }}>
                                                        <Accordion.Header>Sign Document Manually</Accordion.Header>
                                                        <Accordion.Body>
                                                            <label className="m-t-25">Step - 1: Download Form 121</label><br />
                                                            <button className="btn btn-info m-t-10 h-40" onClick={this.handleDownload} >Download Form 121</button><br />
                                                            <label className="m-t-25">Step - 2:  Upload Manually Signed Form 121</label><br />
                                                            <button disabled={this.state.IsESignDisable} className="btn btn-info m-t-10 h-40" onClick={this.handlePopup}>Upload Manually Signed Form 121</button>

                                                            <Alert color="dark" className="m-t-15">
                                                                Ensure you upload a signed declaration, else you will not be able to avail the tax benefit.
                                                            </Alert>
                                                        </Accordion.Body>
                                                    </Accordion.Item>
                                                    <Accordion.Item eventKey="2" style={{ display: `${this.state.IsConsent == 1 ? 'block' : 'none'}` }}>
                                                        <Accordion.Header>Consent</Accordion.Header>
                                                        <Accordion.Body>
                                                            <Alert color="dark" className="m-t-15">
                                                                I hereby declare that the details furnished above are true and correct to the best of my knowledge and belief and I undertake the responsibility to inform you of any changes therein, immediately.
                                                            </Alert>
                                                            <button className="btn btn-info m-t-10 h-40" onClick={this.handleAccept} >I Accept</button><br />

                                                        </Accordion.Body>
                                                    </Accordion.Item>
                                                </Accordion>
                                            </div>
                                        </div>
                                    </TabPane>
                                    <TabPane tabId="hTabsIcons-4" role="tabpanel">
                                        <div className="card m-t-10" >
                                            <div className="card-body">
                                                <h4 className="header-title text-center">Download Signed Form 121 Declaration</h4>
                                                <Row>
                                                    <Col md={4}>

                                                    </Col>
                                                    <Col md={4}>
                                                        <div className="vertical-center">
                                                            <button className="btn btn-success m-t-10 h-40 text-center" onClick={this.handleSignDownload} >Download</button><br />
                                                        </div>
                                                    </Col>

                                                </Row>
                                                <Row>
                                                    <Col md={12}>
                                                        <Alert color="dark" className="text-center m-t-15">
                                                            Note: Copy of the declaration will be send to registered email.
                                                        </Alert>
                                                    </Col>

                                                </Row>
                                            </div>
                                        </div>
                                    </TabPane>
                                </TabContent>
                            </div>

                        </div>
                    </div>

                </div>
                {contentFooter}
            </div>

        );
    }
}

